export default {
    common: {
        actions: '操作',
        add: '新增',
        edit: '修改',
        delete: '刪除',
        more: '更多',
        search: '搜尋',
        reset: '重置',
        export: '匯出',
        submit: '確定',
        confirm: '確定',
        success: '成功',
        warning: '警告',
        error: '錯誤',
        cancel: '取消',
        enable: '啟用',
        disable: '停用',
        expand: '展開/摺疊',
        close: '關閉',
        startDate: '開始日期',
        endDate: '結束日期',
        to: '至',
        yes: '是',
        no: '否',
        noData: '暫無數據'
    },
    template: {
        private: {
            searchPlaceholder: '請輸入模板名稱',
            empty: '沒有找到模板'
        },
        public: {
            searchPlaceholder: '請輸入模板關鍵詞',
            categoryAll: '全部模板',
            defaultCategory: '公共模板',
            use: '使用',
            detail: '詳情',
            empty: '暫無模板',
            total: '共 {count} 條',
            previewMissingId: '當前模板缺少項目ID，無法預覽',
            copyMissingId: '當前模板缺少項目ID，無法複製',
            copyConfirmMessage: '將以該模板複製新項目並跳轉到設計頁，是否繼續？',
            sameAsSource: '與來源項目一致',
            copyNoResponse: '複製失敗：服務無響應',
            copyFailed: '複製失敗',
            copySuccessNoId: '複製成功，但未獲取到新項目ID',
            copySuccessJump: '複製成功，正在跳轉',
            copyFailRetry: '複製失敗，請稍後再試'
        },
        preview: {
            headerTitle: '問卷題目預覽',
            titleDefault: '問卷預覽',
            subtitleDefault: '題目預覽（不展示選項）',
            defaultEstimateTime: '5-10 分鐘',
            questionCount: '共 {count} 道題目',
            estimatedTime: '預計耗時：{time}',
            noOptionsNote: '僅預覽題目，不展示選項',
            sectionTitle: '題目列表',
            untitledQuestion: '未命名題目',
            empty: '暫無題目',
            loadFail: '預覽加載失敗',
            type: {
                TEXT: '問答題',
                TEXTAREA: '多行文本',
                SINGLE: '單選題',
                MULTIPLE: '多選題',
                OPEN: '開放題',
                NUMBER: '數字題',
                DATETIME: '日期題',
                SCORE: '評分題',
                SORT: '排序題',
                UPLOAD: '上傳題',
                TIME: '時間題',
                TIMESTAMP: '時間戳',
                SELECT: '下拉選擇',
                MATRIX_RADIO: '矩陣單選',
                MATRIX_MULTI: '矩陣多選',
                MATRIX_BLANK: '矩陣填空',
                MATRIX_STATISTICS: '矩陣統計',
                MATRIX_COMPOSITION: '矩陣組合',
                THERMODYNAMIC_CHART: '熱力圖',
                COMBINATION: '組合題',
                LOOP: '循環題',
                AUTO_RECORD: '自動記錄'
            }
        }
    },
    fixdata: {
        title: '補充數據中心',
        add: '新增案例',
        updateData: '更新數據',
        updateDataConfirmTitle: '提示',
        updateDataConfirmMessage: '確認執行數據更新？',
        updateDataConfirmOk: '確認',
        updateDataConfirmCancel: '取消',
        updateDataSuccess: '數據更新成功',
        updateDataFail: '數據更新失敗',
        syncQuota: '同步配額',
        syncQuotaPromptTitle: '同步配額',
        syncQuotaPromptMessage: '請輸入項目ID',
        syncQuotaPromptPlaceholder: '例如：455',
        syncQuotaPromptOk: '確認',
        syncQuotaPromptCancel: '取消',
        syncQuotaInvalid: '請輸入純數字的項目ID',
        syncQuotaSuccess: '同步配額已觸發',
        syncQuotaFail: '同步配額失敗',
        search: '搜尋',
        searchPlaceholder: '搜尋補數名稱',
        id: '編號',
        name: '案例名稱',
        caseId: '補數編號',
        caseName: '補數名稱',
        type: '類型',
        typeFix: '補數',
        typeDiscard: '廢棄',
        projectId: '項目ID',
        projectName: '項目名稱',
        createdAt: '創建時間',
        desc: '案例描述',
        recordsCount: '記錄數',
        actions: '操作',
        edit: '編輯',
        import: '導入',
        delete: '刪除',
        addDialogTitle: '新增案例',
        editDialogTitle: '編輯案例',
        form: {
            name: '案例名稱',
            desc: '案例描述',
            ok: '確定',
            save: '保存',
            confirm: '導入'
        },
        upload: {
            rawHint: '將 CSV 或 Excel 檔拖到此處，或',
            clickToUpload: '點擊上傳',
            rawTip: '僅支持 .csv、.xlsx',
            rawTypeOnly: '僅支持CSV或Excel檔',
            rawSelected: '已選擇檔案',
            rawSelectFirst: '請先選擇檔案',
            rawSuccess: '導入成功',
            rawFail: '導入失敗'
        },
        importDialogTitle: '導入補充數據',
        message: {
            inputName: '請輸入案例名稱',
            saved: '保存成功',
            saveFail: '保存失敗'
        },
        deletion: {
            confirm: '確認刪除【{name}】？',
            success: '刪除成功',
            fail: '刪除失敗'
        }
    },
    ops: {
        common: {
            confirm: '確認',
            cancel: '取消',
            refresh: '刷新'
        },
        data: {
            title: '數據運維',
            projectId: '項目ID',
            projectName: '項目名稱',
            remark: '備註',
            isCurrent: '是否當前',
            current: '當前',
            notCurrent: '非當前',
            searchProjectNamePlaceholder: '搜尋項目名稱',
            searchProjectIdPlaceholder: '搜尋項目ID',
            search: '搜尋',
            reset: '重置',
            actions: '操作',
            dataVersion: '數據版本',
            import: '導入',
            export: '匯出',
            restore: '應用',
            pullData: '拉取數據',
            sync: '同步版本',
            syncConfirmTitle: '提示',
            syncConfirmAll: '確認同步全部項目的初始化備份版本？',
            syncConfirmProject: '確認同步項目 {id} 的初始化備份版本？',
            syncSuccess: '同步已觸發',
            syncFail: '同步失敗',
            pullConfirmMessage: '確認拉取項目 {id} 的 v1 數據？',
            pullSuccess: '拉取已觸發',
            pullFail: '拉取失敗',
            listFail: '獲取列表失敗',
            exportFail: '匯出失敗',
            restoreFail: '應用失敗',
            importFail: '導入失敗',
            importSuccess: '導入成功',
            versions: '版本',
            versionsDialogTitle: '項目版本（項目ID：{id}）',
            versionsLoadFail: '獲取項目版本失敗',
            downloadLatestData: '下載最新數據',
            downloadLatestDataFail: '下載最新數據失敗',
            versionId: '數據版本ID',
            createdAt: '創建時間',
            delete: '刪除',
            deleteConfirmTitle: '提示',
            deleteConfirmMessage: '確認刪除版本記錄（ID：{id}）？',
            deleteSuccess: '刪除成功',
            deleteFail: '刪除失敗：{msg}',
            importDialogTitle: '導入版本（項目ID：{id}）',
            importProjectId: '項目ID',
            remarkPlaceholder: '可選',
            importFile: 'Excel檔案',
            importDropHint: '將檔案拖到此處，或',
            importClick: '點擊上傳',
            importTip: '僅支持 .xlsx、.xls',
            importFileRequired: '請選擇Excel檔案',
            selectedFile: '已選擇：',
            restoreConfirmTitle: '提示',
            restoreConfirmMessage: '確認應用項目 {id} 的版本 {version}？該操作會覆蓋當前數據。',
            restoreSuccess: '應用成功'
        },
        quota: {
            title: '配額緩存管理',
            hint: '用於清除配額相關緩存。資料量較大時可能需要等待。',
            clearAll: '清除全部緩存',
            clearByProject: '按項目清除',
            allProjects: '全部項目',
            clearingTip: '正在清除緩存，請耐心等待...',
            clearSuccess: '緩存清除已觸發',
            clearFail: '清除失敗：{msg}',
            clearAllConfirmTitle: '提示',
            clearAllConfirmMessage: '確認清除全部項目的配額緩存？',
            projectPromptTitle: '按項目清除',
            projectPromptMessage: '請輸入項目ID',
            projectPromptPlaceholder: '例如：455',
            projectInvalid: '請輸入純數字的項目ID',
            logTime: '時間',
            logProjectId: '項目ID',
            logResult: '結果',
            searchProjectNamePlaceholder: '搜尋項目名稱',
            searchProjectIdPlaceholder: '搜尋項目ID',
            search: '搜尋',
            reset: '重置',
            projectId: '項目ID',
            projectName: '項目名稱',
            projectDesc: '項目描述',
            createTime: '創建時間',
            actions: '操作',
            syncQuota: '同步配額',
            syncingTip: '正在同步配額，請耐心等待...',
            syncConfirmTitle: '提示',
            syncConfirmMessage: '確認同步項目 {id} 的配額？',
            syncSuccess: '同步已觸發',
            syncFail: '同步失敗：{msg}',
            listFail: '獲取列表失敗'
        },
        activityMonitor: {
            title: '問卷活躍監控',
            window: '活躍窗口',
            win3h: '3小時',
            win6h: '6小時',
            win12h: '12小時',
            win1d: '1天',
            win3d: '3天',
            win5d: '5天',
            unitHour: '小時',
            unitDay: '天',
            unitWeek: '週',
            apply: '應用',
            windowInvalid: '請輸入有效的窗口範圍',
            projectId: '項目ID',
            projectName: '項目名稱',
            projectStatus: '項目狀態',
            statusRun: '運行中',
            lastActiveTime: '最後活躍時間',
            activeAnswerCount: '活躍答卷數',
            windowMinutes: '窗口',
            listFail: '獲取列表失敗'
        },
        dataAdjust: {
            title: '數據調整',
            searchProjectIdPlaceholder: '請輸入項目ID',
            search: '搜尋',
            reset: '重置',
            add: '添加',
            addDialogTitle: '添加調整記錄',
            selectProject: '選擇項目',
            selectPlaceholder: '輸入項目名稱搜尋',
            loadProjectsFail: '獲取項目列表失敗',
            downloadLatestData: '下載最新數據',
            downloadLatestDataFail: '下載最新數據失敗',
            exportOrigin: '匯出原始',
            exportAdjust: '匯出調整',
            exportFail: '匯出失敗',
            switchToOrigin: '切換到調整前',
            switchToAdjust: '切換到調整後',
            editMode: '編輯模式',
            exitEdit: '退出編輯',
            editOnlyAdjust: '請先切換到調整後再編輯',
            addSuccess: '添加成功',
            addFail: '添加失敗',
            projectIdRequired: '請先輸入項目ID',
            summaryTitle: 'done 答卷彙總',
            sourceOrigin: '原始數據',
            sourceAdjust: '調整後數據',
            questionNo: '題號',
            questionType: '題型',
            questionId: '題目ID',
            total: '總數',
            valuesCount: '答案種類',
            value: '答案值',
            count: '數量',
            summaryFail: '獲取彙總失敗',
            recordsTitle: '調整記錄',
            recordId: '記錄ID',
            projectId: '項目ID',
            projectName: '項目名稱',
            createTime: '創建時間',
            updateTime: '更新時間',
            actions: '操作',
            adjust: '調整',
            adjustDialogTitle: '答案統計（項目ID：{id}）',
            listFail: '獲取列表失敗'
        }
    },
    olddata: {
        title: '歷史數據',
        add: '新增',
        searchPlaceholder: '搜尋項目名稱',
        search: '搜尋',
        refresh: '刷新',
        id: '項目編號',
        name: '項目名稱',
        type: '類型',
        typeOld: '舊數據',
        industry: '行業',
        company: '公司',
        desc: '項目描述',
        questionCount: '題目數目',
        answerCount: '答案數目',
        actions: '操作',
        preview: '預覽',
        edit: '編輯',
        view: '查看',
        delete: '刪除',
        addDialogTitle: '新增導入項目',
        editDialogTitle: '編輯項目',
        form: {
            name: '項目名稱',
            desc: '項目描述',
            company: '公司名稱',
            companyPlaceholder: '請輸入公司名稱',
            category: '分類標籤',
            categoryPlaceholder: '請選擇分類',
            dataZip: '數據ZIP',
            dataImported: '數據已導入',
            dataCount: '{count} 條',
            clear: '清空',
            rawData: '原始數據',
            next: '下一頁',
            save: '保存',
            ok: '確定',
            prev: '上一頁',
            confirm: '確認'
        },
        upload: {
            zipHint: '拖拽ZIP到此處，或',
            clickToUpload: '點擊上傳',
            zipTip1: '僅支持 .zip，上傳後將更新條目數',
            zipTip2: '壓縮包需包含 asc 文件與 datamap.txt',
            zipOnly: '僅支持上傳ZIP文件',
            zipSuccess: '舊數據導入成功',
            zipFail: '舊數據導入失敗',
            rawHint: '拖拽原始數據到此處，或',
            rawTip: '支持 Excel（.xlsx/.xls）與 .csv',
            rawSelectFirst: '請先選擇原始數據文件',
            rawSuccess: '原始數據導入成功',
            rawFail: '原始數據導入失敗',
            rawTypeOnly: '僅支持 .csv/.xlsx/.xls 文件',
            rawSelected: '已選擇原始數據文件，請點擊確認導入'
        },
        clear: {
            confirm: '確認清空已導入數據？',
            success: '已清空',
            fail: '清空失敗'
        },
        deletion: {
            confirm: '確認刪除項目「{name}」？刪除後不可恢復',
            success: '已刪除',
            fail: '刪除失敗'
        },
        previewDialog: {
            title: '項目預覽',
            name: '名稱',
            desc: '描述',
            tags: '標籤',
            createdAt: '創建時間',
            updatedAt: '更新時間',
            rowsCount: '條目數',
            close: '關閉',
            viewData: '查看數據'
        },
        message: {
            fetchListFail: '獲取舊數據項目列表失敗',
            inputName: '請輸入名稱',
            saved: '已保存修改',
            createSuccess: '創建成功',
            createFail: '創建失敗',
            refreshed: '已刷新列表'
        },
        detail: {
            back: '返回',
            itemsTag: '條目 {count}',
            cross: '交叉分析',
            exportCsv: '匯出CSV',
            selectQuestionPlaceholder: '選擇題號',
            answerKeywordPlaceholder: '輸入答案關鍵詞',
            search: '搜尋',
            text: '文本',
            value: '值',
            status: '狀態',
            statusValues: {
                completed: '完成',
                inProgress: '進行中',
                failed: '失敗'
            },
            crossDialog: {
                title: '交叉分析',
                demo: '該功能還在開發中，敬請期待',
                close: '關閉',
                ok: '確定'
            },
            message: {
                fetchAnswersFail: '獲取答題數據失敗',
                fetchProjectFail: '獲取項目詳情失敗'
            }
        }
    },
    route: {
        dashboard: '後台管理系統',
        usermanger:'用戶中心',
        introduction: '簡述',
        documentation: '文件',
        permission: '權限測試頁',
        pagePermission: '頁面權限',
        directivePermission: '指令權限',
        icons: '圖標',
        components: '組件',
        componentIndex: '介紹',
        tinymce: '富文本編輯器',
        markdown: 'Markdown',
        jsonEditor: 'JSON編輯器',
        dndList: '列表拖拽',
        splitPane: 'Splitpane',
        avatarUpload: '頭像上傳',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'CountTo',
        componentMixin: '小組件',
        backToTop: '返回頂部',
        dragDialog: '拖拽 Dialog',
        dragKanban: '可拖拽看板',
        charts: '圖表',
        keyboardChart: '鍵盤圖表',
        lineChart: '折線圖',
        mixChart: '混合圖表',
        example: '綜合實例',
        Table: 'Table',
        dynamicTable: '動態Table',
        dragTable: '拖拽Table',
        inlineEditTable: 'Table內編輯',
        complexTable: '綜合Table',
        treeTable: '樹形表格',
        customTreeTable: '自定義樹表',
        tab: 'Tab',
        form: '表單',
        createForm: '創建表單',
        editForm: '編輯表單',
        errorPages: '錯誤頁面',
        page401: '401',
        page404: '404',
        errorLog: '錯誤日誌',
        excel: 'Excel',
        exportExcel: '匯出 Excel',
        selectExcel: '匯出已選項',
        uploadExcel: '上傳 Excel',
        zip: 'Zip',
        exportZip: '匯出 Zip',
        theme: '換膚',
        clipboardDemo: '剪貼簿',
        i18n: '國際化'
    },
    navbar: {
        logOut: '登出',
        dashboard: '首頁',
        github: '項目地址',
        screenfull: '全螢幕',
        theme: '換膚',
        projectManagement: '項目管理',
        recycleBin: '回收中心',
        systemManagement: '系統管理',
        userManagement: '用戶管理',
        roleManagement: '角色管理',
        menuManagement: '選單管理',
        codeGeneration: '代碼生成',
        projectList: '專案數據圖表',
        automatedReport: '自動產出報告',
        favoritesCenter: '收藏中心',
        collaborativeSurvey: '協作問卷',
        pushCenter: '推送中心',
        systemSettings: '系統配置'
    },
    login: {
        title: '系統登入',
        logIn: '登入',
        username: '帳號名稱',
        password: '密碼',
        any: '隨便填',
        thirdparty: '第三方登入',
        thirdpartyTips: '本地不能模擬，請結合自己業務進行模擬！！！'
    },
    publicSite: {
        navigation: '易調研系統公共導航',
        brandName: '易調研系統',
        brandAlt: '易調研系統 Logo',
        brandSubtitle: 'YiSurvey Platform',
        home: '首頁',
        capabilities: '產品能力',
        pricing: '價格',
        contact: '聯繫我們',
        login: '登入',
        register: '註冊'
    },
    landingPage: {
        revealEyebrow: 'Survey Intelligence Online',
        taglinePlain: '讓每一個問題，變成可行動的洞察',
        heroEyebrow: 'Survey Intelligence Platform',
        productName: '易調研系統',
        heroTagline: '讓每一個問題，變成可行動的洞察。',
        heroDescription: '從問卷設計、樣本投放、配額監控到數據洞察，把複雜調研流程壓縮進一個清晰、可協作、可追蹤的系統。',
        demoCta: '預約演示',
        pricingCta: '查看價格',
        dashboardCta: '進入工作台',
        heroProofs: ['問卷設計', '樣本配額', '實時監控', '數據洞察'],
        engineTitle: 'Survey Intelligence Engine',
        engineLabel: '有效樣本信號',
        stage: {
            questionKicker: '問卷設計',
            questionTitle: '品牌認知調研',
            sampleKicker: '樣本流轉',
            responseCount: '2,847 份答卷',
            quotaKicker: '配額監控',
            quotaLabel: '區域 / 年齡 / 渠道',
            insightKicker: '實時洞察',
            logicChip: '智能邏輯',
            cleanChip: '清洗數據'
        },
        workflowEyebrow: 'YiSurvey Workflow',
        workflowTitle: '從項目創建，到報告產出，全流程都在一個系統裡推進。',
        workflowDescription: '項目進入易調研系統後，可以完成問卷設計、發佈回收、配額監控、數據補充、統計下載和專題分析，讓調研團隊少切換工具，多沉澱資產。',
        visual: {
            projectQuestion: '把所有調研項目，先放進一個可追蹤的工作台。',
            projectTags: ['創建項目', '題量統計', '回收進度', '分享碼複製'],
            logicTitle: '邏輯控制',
            logicPreview: '跳轉 / 複製 / 腳本預覽',
            designChannels: ['基礎題型', '循環題', 'MaxDiff', 'AI 腳本', '多語言'],
            launchLabel: '發佈 / 配額 / 郵件',
            quotaBadge: '配額完成監控',
            analysisLabel: '數據 / 分析 / 報告',
            insightHeadline: '數據查看、補充修正、統計下載和專題分析一起收口。',
            analysisActions: ['Excel / SPSS', '音頻下載', '補充數據', '開放題分析', '自動化報告']
        },
        evidenceEyebrow: 'Evidence Chain',
        evidenceTitle: '讓每一個問題，變成可行動的洞察。',
        evidenceDescription: '一份調研不是靠一個漂亮大屏被證明，而是從立項、問卷、發佈、配額、數據到分析，每一步都有可追溯的交付物。',
        caseFileTitle: '新品包裝認知調研',
        caseFileMeta: ['28 題', '1,426 份答卷', '6 個配額維度'],
        caseFileStamp: '可追溯',
        useCaseEyebrow: 'Use Cases',
        useCaseTitle: '從一次包裝測試，',
        useCaseTitleAccent: '到長期品牌追蹤。',
        useCaseDescription: '易調研系統適合承接需要設計問卷、控制樣本、沉澱數據並交付分析結果的項目；不同場景使用同一條調研作業鏈路，但保留各自的交付痕跡。',
        scenarioBoardLabel: 'Research Scenario Board',
        sharedFlowLabel: '共同鏈路',
        sharedFlowValue: '問卷設計 / 發佈回收 / 配額監控 / 數據交付',
        contactEyebrow: 'Demo Access',
        contactTitle: '準備把調研流程接入易調研系統？',
        contactDescription: '先預約演示，或進入價格頁了解不同團隊規模的方案。',
        scenes: {
            project: {
                label: 'Project Hub',
                title: '項目先進入統一工作台。',
                desc: '新建、複製、移動、關閉、延期和回收站管理都圍繞項目展開；題量、投放量和完成數直接回到項目列表裡。',
                points: ['項目創建', '文件夾歸檔', '題量 / 回收統計']
            },
            design: {
                label: 'Question Designer',
                title: '複雜問卷在設計器裡完成。',
                desc: '基礎題型、邏輯設置、題型切換、循環題、MaxDiff、前中後置腳本、AI 腳本、多語言和資源管理集中在同一個設計界面。',
                points: ['題型組件', '邏輯 / 腳本', '循環題 / MaxDiff']
            },
            launch: {
                label: 'Launch Control',
                title: '發佈、鏈接、配額和觸達同步推進。',
                desc: '項目發佈、歷史鏈接、鏈接配置、配額方案、配額監控、郵件模板、發件人、名單分組和發送記錄共同支撐回收執行。',
                points: ['發佈鏈接', '配額方案', '郵件觸達']
            },
            analysis: {
                label: 'Data & Report',
                title: '數據回收後還能繼續處理和分析。',
                desc: '答卷數據、統計視圖、Excel / SPSS / 音頻下載、補充數據、配額同步、開放題分析、品名測試、試吃分析和自動化報告形成閉環。',
                points: ['數據下載', '補充數據', '專題分析']
            }
        },
        evidenceSteps: {
            project: {
                label: 'Project Brief',
                title: '項目立項',
                desc: '項目名稱、狀態、文件夾、題量和答卷量先被歸檔。',
                artifacts: ['項目列表', '狀態篩選', '分享碼']
            },
            questionnaire: {
                label: 'Questionnaire',
                title: '問卷結構',
                desc: '題型組件、大綱、題庫、循環題和 MaxDiff 形成可編輯結構。',
                artifacts: ['題型組件', '大綱', 'MaxDiff']
            },
            launch: {
                label: 'Launch Link',
                title: '發佈回收',
                desc: '發佈項目、歷史鏈接、鏈接配置和郵件觸達綁定同一項目。',
                artifacts: ['發佈鏈接', '歷史鏈接', '郵件模板']
            },
            quota: {
                label: 'Quota Record',
                title: '配額記錄',
                desc: '樣本狀態、成功率、配額方案和矩陣表保留執行過程。',
                artifacts: ['樣本統計', '配額矩陣', '完成率']
            },
            dataset: {
                label: 'Dataset',
                title: '數據交付',
                desc: '答卷查看、補充數據、Excel / SPSS / 音頻下載進入交付包。',
                artifacts: ['Excel', 'SPSS', '音頻']
            },
            insight: {
                label: 'Insight',
                title: '專題分析',
                desc: '開放題、品名測試和試吃分析承接數據後的判斷。',
                artifacts: ['開放題', '品名測試', '試吃分析']
            }
        },
        useCases: {
            brand: {
                label: 'Brand & Package',
                period: '2-4 週',
                title: '品牌與包裝測試',
                desc: '驗證消費者看到包裝、概念或品牌信息後的認知、偏好、購買意願和開放反饋。',
                flow: ['包裝概念', '認知偏好', '開放反饋'],
                deliverables: ['Excel / SPSS', '開放題分析', '結論沉澱']
            },
            trial: {
                label: 'Product Trial',
                period: '現場 / 入戶',
                title: '新品試吃與產品測試',
                desc: '圍繞配額篩選、體驗記錄、品名測試和試吃維度分析，支撐產品上市前判斷。',
                flow: ['配額篩選', '體驗記錄', '產品對比'],
                deliverables: ['配額監控', '試吃分析', '品名測試']
            },
            tracking: {
                label: 'Tracking Study',
                period: '月度 / 季度',
                title: '長期品牌追蹤',
                desc: '復用歷史項目、題庫、術語和數據版本，把週期性回收變成可對比的趨勢資產。',
                flow: ['項目複製', '週期回收', '趨勢沉澱'],
                deliverables: ['歷史鏈接', '數據版本', '週期報告']
            }
        }
    },
    loginPage: {
        kickedTitle: '帳號在別處登入',
        kickedDesc: '您的帳號已在其他裝置登入，本裝置已被迫下線。如非本人操作，請立即修改密碼。',
        loginTitle: '登入',
        username: '賬號名稱',
        usernameLogin: '用戶名/手機號',
        loginModePassword: '密碼登入',
        loginModeSms: '簡訊驗證碼登入',
        loginModeLabel: '登入方式',
        password: '密碼',
        forgotPassword: '忘記密碼？',
        login: '登入',
        orLoginWith: '或使用社交平台登入',
        registerTitle: '註冊',
        register: '註冊',
        orRegisterWith: '或使用社交平台註冊',
        hello: '你好，歡迎',
        noAccount: '還沒有帳號？',
        toRegister: '註冊',
        welcomeBack: '歡迎回來！',
        hasAccount: '已經有帳號？',
        toLogin: '登入',
        usernameRequired: '請輸入用戶名',
        usernameInvalid: '用戶名需包含字母',
        passwordRequired: '請輸入密碼',
        loginSuccess: '登入成功',
        loginFailed: '登入失敗，請稍後再試',
        invalidCredentials: '帳號或密碼錯誤',
        accountNotFound: '帳號不存在',
        mobileNotRegistered: '該手機號尚未註冊',
        passwordIncorrect: '密碼錯誤',
        pricingPlans: '收費標準',
        authEyebrow: 'YiSurvey / PUBLIC ACCESS',
        authHeadlinePrimary: '從一個問題開始，',
        authHeadlineAccent: '把答案帶回團隊。',
        authDescription: '登入易調研系統，繼續管理問卷、樣本、回收數據與調研洞察。',
        flowQuestionnaire: '問卷設計',
        flowLaunch: '發布觸達',
        flowCollection: '數據回收',
        flowInsight: '洞察交付',
        workspaceReady: '工作台已就緒',
        workspaceTraceable: '過程可追蹤',
        workspaceCollaborative: '團隊可協作',
        authModeLabel: '登入或註冊',
        loginKicker: 'RETURN TO YOUR WORKSPACE',
        registerKicker: 'START A NEW STUDY',
        loginSubtitle: '使用你的帳號繼續調研工作。',
        registerSubtitle: '建立帳號，開始組織下一次調研。',
        usernamePlaceholder: '用戶名/手機號',
        passwordPlaceholder: '輸入密碼',
        mobile: '手機號碼',
        mobilePlaceholder: '輸入手機號碼',
        mobileRequired: '請輸入手機號碼',
        mobileInvalid: '請輸入有效的中國大陸手機號碼',
        smsCode: '手機驗證碼',
        smsCodePlaceholder: '輸入驗證碼',
        smsCodeRequired: '請輸入手機驗證碼',
        smsCodeInvalid: '手機驗證碼無效或已過期',
        sendSmsCode: '獲取驗證碼',
        smsCountdown: '{seconds}s 後重發',
        smsSent: '驗證碼已發送，請注意查收',
        smsTooFrequent: '驗證碼發送過於頻繁，請稍後再試',
        smsSendFailed: '驗證碼發送失敗，請稍後重試',
        email: '郵箱',
        emailOptional: '郵箱（選填）',
        emailPlaceholder: '輸入工作郵箱',
        emailRequired: '請輸入郵箱',
        emailInvalid: '請輸入有效的郵箱地址',
        loggingIn: '登入中...',
        registering: '註冊中...',
        contactSupport: '登入遇到問題？聯繫支持',
        supportSubject: '易調研系統登入支持',
        registerSuccess: '註冊成功，請使用新帳號登入',
        registerFailed: '註冊失敗，請稍後再試',
        mobileExists: '手機號碼已被註冊',
        accountExists: '帳號、手機號碼或郵箱已存在'
    },
    documentation: {
        documentation: '文件',
        github: 'Github 地址'
    },
    // ===== 即時協同（編輯端 WebSocket）=====
    collab: {
        online: '線上協作者',
        someone: '協作者',
        updated: '更新了',
        isEditing: '正在編輯',
        updatedBadge: '已被 {name} 更新',
        loadLatest: '載入最新',
        overwrite: '用我的版本覆蓋',
        loadLatestBtn: '載入對方的版本',
        conflictTitle: '儲存衝突',
        conflictDesc: '該題已被其他協作者修改，你的本次修改尚未儲存。',
        conflictTip: '「用我的版本覆蓋」將以你的內容取代對方修改；「載入對方的版本」將放棄你的本次修改。',
        overwriteSuccess: '已覆蓋儲存',
        overwriteFail: '覆蓋儲存失敗',
        loadedLatest: '已載入對方的最新版本',
        reconnecting: '即時協同連線中斷，正在重連…',
        degraded: '即時協同暫不可用（將自動重試）'
    },
    permission: {
        roles: '你的權限',
        switchRoles: '切換權限'
    },
    components: {
        documentation: '文件',
        tinymceTips: '富文本是管理後台一個核心的功能，但同時又是一個有很多坑的地方。在選擇富文本的過程中也走了不少的彎路，市面上常見的富文本都基本用過了，最終權衡了一下選擇了Tinymce。更詳細的富文本比較和介紹見',
        dropzoneTips: '由於我司業務有特殊需求，而且要傳七牛 所以沒用第三方，選擇了自己封裝。代碼非常的簡單，具體代碼你可以在這裡看到 @/components/Dropzone',
        stickyTips: '當頁面滾動到預設的位置會吸附在頂部',
        backToTopTips1: '頁面滾動到指定位置會在右下角出現返回頂部按鈕',
        backToTopTips2: '可自定義按鈕的樣式、show/hide、出現的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        imageUploadTips: '由於我在使用時它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用，優先還是使用官方版本。'
    },
    table: {
        dynamicTips1: '固定表頭, 按照表頭順序排序',
        dynamicTips2: '不固定表頭, 按照點擊順序排序',
        dragTips1: '預設順序',
        dragTips2: '拖拽後順序',
        title: '標題',
        importance: '重要性',
        type: '類型',
        remark: '點評',
        reviewer: '審核人',
        id: '序號',
        date: '時間',
        author: '作者',
        readings: '閱讀數',
        status: '狀態',
        publish: '發布',
        draft: '草稿',
    },
    errorLog: {
        tips: '請點擊右上角bug小圖標',
        description: '現在的管理後台基本都是spa的形式了，它增強了用戶體驗，但同時也會增加頁面出問題的可能性，可能一個小小的疏忽就導致整個頁面的死鎖。好在 Vue 官網提供了一個方法來捕獲處理異常，你可以在其中進行錯誤處理或者異常上報。',
        documentation: '文件介紹'
    },
    excel: {
        export: '匯出',
        selectedExport: '匯出已選項',
        placeholder: '請輸入文件名(預設excel-list)'
    },
    zip: {
        export: '匯出',
        placeholder: '請輸入文件名(預設file)'
    },
    theme: {
        change: '換膚',
        documentation: '換膚文件',
        tips: 'Tips: 它區別於 navbar 上的 theme-pick, 是兩種不同的換膚方法，各自有不同的應用場景，具體請參考文件。'
    },
    tagsView: {
        close: '關閉',
        closeOthers: '關閉其它',
        closeAll: '關閉所有'
    },
    dashboard: {
        kpi: {
            surveyCount: "問卷數",
            userCount: "用戶數",
            ongoingSurvey: "進行中的問卷",
            recoveryRate: "問卷回收率"
        },
        hero: {
            badge: "YISURVEY · SMART SURVEY SYSTEM",
            title: "一體化問卷設計與數據洞察平台",
            desc: "支援問卷編輯、複雜邏輯編排、腳本擴展、樣本與配額管理，幫助團隊快速構建高品質調研專案並持續追蹤效果。",
            enterProjectList: "進入項目列表",
            signalRealtime: "即時回收",
            signalSmart: "智慧甄別",
            cube: {
                survey: "問卷",
                sample: "樣本",
                logic: "邏輯",
                quota: "配額",
                insight: "洞察",
                analysis: "分析"
            }
        },
        entry: {
            editorTitle: "問卷編輯器",
            editorDesc: "可視化搭建題型結構，支援題目批次維護、模板複用與多語言擴展。",
            logicTitle: "邏輯與腳本能力",
            logicDesc: "支援跳轉邏輯、顯示條件、配額規則與腳本處理，滿足複雜業務場景。",
            deliveryTitle: "投放與分析閉環",
            deliveryDesc: "覆蓋連結投放、樣本回收、品質甄別與結果分析，提升整體調研效率。"
        },
        trend: "數據趨勢統計",
        client: "客戶端",
        browser: "瀏覽器",
        system: "系統",
        newSurvey: "新問卷",
        announcement: "公告"
    },
    project: {
        collaborator: {
            sharedWithMe: '與我共享',
            readonly: '只可檢視',
            share: '共享',
            view: '檢視',
            sharedFrom: '共享自',
            title: '共享專案',
            tip: '被共享的成員可以檢視該專案的最新內容（題目、設定、答卷、統計），但不能修改專案。',
            searchPlaceholder: '輸入使用者帳號或姓名搜尋（至少2個字元）',
            search: '搜尋',
            searchResult: '搜尋結果',
            invite: '邀請',
            memberList: '已共享成員',
            emptyMembers: '尚未共享給任何人',
            emptySearch: '沒有找到符合的使用者',
            remove: '移除',
            close: '關閉',
            readonlyTip: '該專案僅向您開放檢視權限，您可以瀏覽全部內容，但不能修改',
            needKeyword: '請輸入至少2個字元',
            inviteSuccess: '已共享給該使用者',
            inviteFail: '共享失敗',
            removeSuccess: '已移除該成員',
            removeFail: '移除失敗',
            sidebarReadonlyTip: '僅檢視共享：可以瀏覽內容，不能修改',
            bannerPrefix: '該專案由',
            bannerSuffix: '共享給您，您可以檢視全部內容（含答卷與統計），但不能修改。',
            otherUser: '其他使用者',
            tip2: '被邀請的成員需要確認後才可檢視該專案。確認後可以檢視題目、設定、答卷和統計，但不能修改。',
            inviteSent: '邀請已送出，等待對方確認',
            statusPending: '待確認',
            statusAccepted: '已加入',
            statusRejected: '已拒絕',
            reinvite: '重新邀請',
            invitePanelTitle: '您有新的專案共享邀請',
            collapse: '收合',
            expand: '展開',
            invitedBy: '來自',
            accept: '接受',
            reject: '拒絕',
            acceptSuccess: '已接受邀請，專案已加入您的清單',
            acceptFail: '接受邀請失敗',
            rejectSuccess: '已拒絕該邀請',
            rejectFail: '拒絕邀請失敗',
            searchFailed: '搜尋失敗',
            tip3: '按模組為成員設定權限：「只可檢視」的模組只能瀏覽內容，「可編輯」的模組可以修改。被邀請人確認後生效；未授權的模組對方完全不可見。',
        },
        permission: {
            module: '模組',
            none: '無權限',
            read: '只可檢視',
            write: '可編輯',
            editButton: '修改權限',
            configTitle: '設定權限',
            configTitleEdit: '修改權限',
            save: '儲存',
            saveSuccess: '權限已更新',
            saveFail: '權限更新失敗',
            defaultTip: '預設全部為「只可檢視」；請按需要調整各模組檔位後再傳送邀請。',
            pureReadOnlyTip: '「資料下載」「統計分析」為檢視類模組，沒有「可編輯」檔位。',
            dataWriteTip: '「資料」選「可編輯」才能修改問卷狀態、刪除問卷（含資料頁「批次維運」）；選「只可檢視」只能瀏覽答卷。',
            moreItems: '等 {n} 項',
            modules: {
                design: '編輯問卷',
                setting: '問卷設定',
                data: '資料',
                download: '資料下載',
                statistics: '統計分析',
                quota: '配額管理',
                publish: '發布與收集'
            }
        },
        transfer: {
            title: '轉移項目',
            action: '轉移',
            ownerLabel: '項目所有者',
            tipShort: '轉移後該項目的所有者會變更，您將不再擁有該項目的管理權限。',
            tip: '轉移後，該項目的所有者會變更為新用戶，您將立即失去該項目的全部訪問權（含只讀查看）。此操作不可撤銷。',
            projectCount: '待轉移項目數',
            newOwner: '新所有者',
            searchPlaceholder: '輸入用戶帳號或姓名搜尋（至少2個字符）',
            search: '搜尋',
            searchResult: '搜尋結果',
            select: '選擇',
            change: '更換',
            emptySearch: '沒有找到匹配的用戶',
            needKeyword: '請輸入至少2個字符',
            noProject: '請先選擇要轉移的項目',
            searchFailed: '搜尋失敗',
            confirm: '確認轉移',
            confirmTitle: '確認轉移項目',
            confirmMessage: '確定要把 {count} 個項目轉移給 {name} 嗎？轉移後您將失去這些項目的全部訪問權，且此操作不可撤銷。',
            success: '已轉移 {count} 個項目',
            fail: '轉移失敗',
        },
        id: "項目ID",
        name: "項目名",
        nameOrId: "項目名/項目ID",
        status: "狀態",
        createTime: "創建時間",
        creator: "創建人",
        all: "全部",
        design: "設計中",
        progress: "發布中",
        paused: "暫停中",
        completed: "已結束",
        expireOverlayText: '專案已過期，請選擇關閉或延期',
        extendProject: '確認延期',
        closeProject: '確認關閉',
        extendSuccess: '延期成功',
        extendFail: '延期失敗',
        closeSuccess: '專案已關閉',
        closeFail: '關閉失敗',
        closeProjectTitle: '關閉專案',
        closeProjectTip: '關閉後問卷連結將無法訪問，確定關閉？',
        noData: "暫無數據",
        stats: "統計",
        search: "搜尋",
        quotaMonitor: '配額監控',
        metrics: {
            questions: '題目',
            launch: '投放',
            answers: '答案'
        },
        config: {
            config: '資訊',
            info: '資訊',
            link: '連結',
            settings: '設定',
            thirdParty: '第三方',
            language: '語言',
            display: '顯示',
            status: '狀態',
            quota: '配額設定',
            share: '分享',
            baseInfo: '基本信息',
            projectName: '項目名稱',
            projectDescription: '項目描述',
            organization: '所屬組織',
            creator: '創建人',
            createTime: '創建時間',
            updateTime: '更新時間',
            save: '保存',
            linkSettings: '連結設定',
            surveyLink: '問卷連結',
            shareLink: '分享連結',
            copy: '複製',
            baseSettings: '基本設定',
            surveyStatus: '問卷狀態',
            on: '開啟',
            off: '關閉',
            allowRepeat: '允許重複提交',
            showProgress: '顯示進度條',
            thirdPartyIntegration: '第三方集成',
            wechat: '微信集成',
            workWechat: '企業微信',
            dingtalk: '釘釘',
            languageSettings: '語言設定',
            defaultLanguage: '預設語言',
            supportedLanguages: '支援語言',
            zhCN: '簡體中文',
            enUS: 'English',
            displaySettings: '顯示設定',
            themeColor: '主題色',
            fontSize: '字體大小',
            showLogo: '顯示Logo',
            projectStatus: '項目狀態',
            currentStatus: '當前狀態',
            startTime: '開始時間',
            endTime: '結束時間',
            quotaManage: '配額管理',
            surveyLimit: '問卷配額',
            storageLimit: '儲存空間',
            apiLimit: 'API調用次數',
            unitMB: 'MB',
            linkCopied: '連結已複製到剪貼簿',
            saving: '配置已保存',
            copySuccess: '複製成功',
            copyFailed: '複製失敗',
            saveSuccess: '保存成功',
            saveFailed: '保存失敗',
            fetchInfoFail: '獲取項目信息失敗',
            finishConfirmTitle: '設置項目為已結束',
            finishConfirmMessage: '將項目狀態設置為“已結束”後，線上問卷將會被鎖定，無法繼續答題或修改。是否繼續？',
            finishConfirmButton: '繼續保存',
            ongoing: '進行中',
            finished: '已結束',
            paused: '已暫停',
            deleted: '已刪除',
        },
        responses: "響應",
        views: "瀏覽",
        completion: "完成率",
        emptyTip: "暫無數據",
        emptyCreate: "創建項目",
        deleteSuccess: "刪除成功",
        deleteFail: "刪除失敗",
        confirmDelete: "確認刪除",
        confirmDeleteTip: "確定要刪除項目 \"{name}\" 嗎？",
        createProject: {
            createProject: "創建項目",
            selectType: '選擇項目類型',
            regular: '常規問卷',
            regularDesc: '從零開始創建一個新的問卷項目',
            template: '導入模板',
            templateDesc: '從預設模板中快速創建項目',
            copy: '複製項目',
            copyDesc: '基於現有項目創建副本',
            shareCode: '從分享碼複製項目',
            shareCodeDesc: '透過分享碼複製一個項目',
            ai: 'AI解析',
            aiDesc: '使用AI自動生成問卷結構',
            aiBadge: '測試版',
            downloadExcelTemplate: '下載Excel文件格式模板',
            downloadJsonTemplate: '下載JSON文件格式模板',
            uploadTip: '將文件拖到此處，或',
            clickUpload: '點擊上傳',
            uploadNotice: '注意：請上傳excel,json文件，快速創建項目',
            searchProject: '搜尋項目',
            search: '搜尋',
            keepLogic: '保留邏輯',
            keepScript: '保留腳本',
            createTime: '創建時間：',
            questionCount: '題目數：',
            aiPlaceholder: '請輸入您想要創建的問卷內容描述，例如：創建一個關於員工滿意度調查的問卷，包含工作環境、薪資待遇、職業發展等方面的问题',
            aiStart: '開始解析',
            aiClear: '重設',
            aiTip1: 'AI將根據您的描述自動生成問卷結構',
            aiTip2: '建議描述越詳細，生成的問卷結構越準確',
            info: '項目信息',
            name: '項目名稱',
            namePlaceholder: '請輸入項目名稱',
            organization: '所屬組織',
            organizationPlaceholder: '請輸入所屬組織',
            description: '項目描述',
            descriptionPlaceholder: '請輸入項目描述',
            cancel: '取消',
            create: '創建項目',
            uploadTemplate: '請上傳模板文件',
            selectCopyProject: '請選擇要複製的項目',
            aiInputRequired: '請填寫AI解析內容描述',
            aiParseRequired: '請先進行AI解析',
            createSuccess: '項目創建成功',
            createFail: '創建項目失敗',
            createFailRetry: '創建項目失敗，請稍後重試',
        },
        folder: {
            more: '更多',
            newFolder: '新建文件夾',
            rename: '重命名',
            adjustOrder: '調整排序',
            cancelClassification: '取消分類',
            assignToFolder: '添加到分類',
            createFolderTitle: '新建文件夾',
            editFolderTitle: '編輯文件夾',
            sortFolderTitle: '調整排序',
            assignToFolderTitle: '添加到分類',
            nameLabel: '名稱',
            sortLabel: '排序',
            selectFolderLabel: '選擇文件夾',
            selectFolderPlaceholder: '選擇文件夾'
        },
        share: {
            generateTitle: '生成分享碼',
            sourceProjectId: '源項目ID',
            keepLogic: '保留邏輯',
            keepScript: '保留腳本',
            keepI18n: '保留國際化',
            keepPanel: '保留面板',
            keepQuota: '保留配額',
            generate: '生成',
            generateSuccess: '生成成功',
            generateFail: '生成失敗',
            shareCode: '分享碼',
            copy: '複製',
            copyTitle: '從分享碼複製項目',
            inputShareCode: '分享碼',
            shareCodePlaceholder: '貼上 shareCode（body.sig）',
            newProjectName: '新項目名稱',
            projectNameOptional: '可選：不填則使用「源項目名_copy」',
            description: '項目描述',
            descriptionPlaceholder: '可選',
            organization: '所屬組織',
            organizationPlaceholder: '可選',
            copyAction: '複製項目',
            copySuccess: '複製成功',
            copyFail: '複製失敗'
        },
        linkConfig: {
            refresh: '重新整理',
            latestLinks: '最新連結',
            historyLinks: '歷史連結',
            noLinks: '暫無{type}',
            filterLabel: '篩選條件',
            selectTypePlaceholder: '選擇類型',
            all: '全部',
            prod: '正式',
            test: '測試',
            offline: '離線',
            columns: {
                id: 'ID',
                linkUrl: '連結地址',
                type: '類型',
                createTime: '創建時間',
                status: '狀態',
                version: '版本',
                tags: '標籤',
                actions: '操作'
            },
            tags: {
                idCtrl: '問卷ID控制',
                ipCtrl: 'IP控制',
                guidCtrl: 'GUID控制',
                breakpointCtrl: '答題斷點控制',
                isNav: '顯示導航欄',
                isPre: '顯示上一題按鈕',
                isAgain: '線下連結報別重答',
                offline: '離線',
                isTest: '測試'
            },
            noLatestLinks: '未找到連結',
            noHistoryLinks: '沒有歷史連結',
            loadFail: '加載連結失敗',
            loadHistoryFail: '加載歷史連結失敗',
            testLink: '測試連結',
            prodLink1: '正式連結1',
            prodLink2: '正式連結2',
            offlineVersion: '離線版本',
            custom: '自定義',
            unknownLink: '未知連結',
            disableConfirm: '確定要禁用此連結嗎？',
            disableConfirmTitle: '禁用連結確認',
            disableConfirmButton: '確定禁用',
            enableConfirm: '確定要啟用此連結嗎？',
            enableConfirmTitle: '啟用連結確認',
            enableConfirmButton: '確定啟用',
            version: '版本',
            typeLabel: '類型',
            category: '分類',
            enabledTip: '連結已啟用',
            disabledTip: '連結已禁用',
            operationFail: '操作失敗，請重試'
        },
        languageConfig: {
            enableI18n: '開啟國際化',
            modeLabel: '開啟國際化',
            modeOff: '不開啟',
            modeMulti: '多語言',
            modeSingle: '單語言',
            selectDefaultPlaceholder: '請選擇預設語言',
            fetchFail: '獲取語言配置失敗',
            defaultMustInSupported: '預設語言必須在支援語言列表中',
            supportedRequired: '請至少選擇一種支援語言',
            saveSuccess: '語言配置保存成功',
            saveFail: '保存語言配置失敗',
            langNames: {
                cn: '中文',
                zh_TW: '繁體中文',
                cantonese: '粵語',
                en: '英文',
                th: '泰文',
                fr: '法語',
                ru: '俄語',
                ar: '阿拉伯語',
                es: '西班牙語',
                de: '德語',
                pt: '葡萄牙語',
                jp: '日語',
                hi: '印地語',
                it: '義大利語',
                pl: '波蘭語',
                ms: '馬來語',
                vi: '越南語',
                tl: '他加祿語',
                id: '印尼語',
                my: '緬甸語',
                ko: '韓語',
                la: '拉丁語',
            }
        },
        quotaSchemeList: {
            backToProjectConfig: '返回項目配置',
            title: '配額方案管理',
            listTitle: '配額方案列表',
            refresh: '刷新',
            refreshSuccess: '刷新成功',
            create: '新建配額方案',
            loading: '加載中...',
            emptyTitle: '暫無配額方案',
            emptyDesc: '創建您的第一個配額方案來開始管理問卷配額',
            emptyHint: '點擊右側按鈕創建第一個配額方案',
            noDescription: '暫無描述',
            totalQuota: '總配額',
            usedQuota: '已使用',
            configureQuota: '配置配額',
            configured: '已配置',
            dialog: {
                createTitle: '新增配額設定',
                editTitle: '編輯配額方案',
                addControlTitle: '新增配額控制',
                create: '創建',
                save: '保存'
            },
            form: {
                name: '方案名稱',
                description: '方案描述',
                status: '啟用狀態',
                namePlaceholder: '請輸入配額方案名稱',
                descriptionPlaceholder: '請輸入配額方案描述（可選）',
                rules: {
                    nameRequired: '請輸入方案名稱',
                    nameLength: '長度在 2 到 50 個字符'
                }
            },
            messages: {
                loadFail: '加載配額方案失敗',
                copySuccess: '配額方案複製成功',
                copyFail: '複製配額方案失敗',
                deleteConfirmText: '確定要刪除配額方案"{name}"嗎？',
                deleteConfirmTitle: '確認刪除',
                deleteSuccess: '刪除成功',
                deleteFail: '刪除失敗',
                createSuccess: '創建成功',
                updateSuccess: '更新成功',
                createFail: '創建失敗',
                updateFail: '更新失敗'
            },
            copySuffix: ' - 副本'
        },
        quotaConfig: {
            backToSchemeList: '返回配額方案列表',
            title: '配額設定',
            enableControl: '啟用配額控制',
            enableHint: '注意：開啟配額控制後將對答卷進行配額限制，達到配額限制後將無法繼續答卷',
            advancedTitle: '高級配額設定',
            stubLabel: 'STUB題目（行）：',
            headerLabel: 'HEADER題目（列）：',
            baseLabel: 'BASE篩選題目：',
            baseDimensionLabel: 'BASE題目：',
            selectStubPlaceholder: '請選擇STUB題目',
            selectHeaderPlaceholder: '請選擇HEADER題目',
            selectBasePlaceholder: '請選擇BASE題目',
            quotaTableTitle: '配額分配表格',
            currentTotal: '當前配額總數：',
            baseFilterLabel: 'BASE篩選條件：',
            selectFilterPlaceholder: '請選擇篩選條件',
            total: '總計',
            option: '選項',
            quota: '配額',
            share: '佔比',
            status: '狀態',
            statusUnset: '未設定',
            statusUnlimited: '不限制',
            statusBlocked: '不允許',
            statusLimited: '限額',
            rowTotal: '行總計',
            columnTotal: '列總計',
            hintsTitle: '配額設定說明',
            hintNoLimit: '配額值為 -1 表示不限制該組合',
            hintNotAllowed: '配額值為 0 表示不允許該組合',
            hintPositive: '配額值為正數表示該組合的最大允許數量',
            hintGrandTotal: '總計會自動統計所有有效配額值（不包括-1和0）',
            hintEffectiveStage: '配額控制僅在問卷收集階段生效',
            saveSettings: '保存配額設定',
            reset: '重置',
            currentSchemePrefix: '當前方案：',
            noSelectionTip1: '請選擇左側的配額方案進行設定',
            noSelectionTip2: '或點擊上方按鈕創建新的配額控制方案',
            messages: {
                loadQuotaFail: '加載配額數據失敗',
                loadQuestionsFail: '加載題目列表失敗',
                saveSuccess: '配額設定保存成功',
                saveFail: '保存配額設定失敗'
            },
            unnamedQuestion: '未命名題目',
            unknownQuestion: '未知題目',
            noOptions: '該題目暫無可配置選項',
            progressPauseTitle: '配額進度自動暫停',
            progressPauseDesc: '達到設定進度後自動將項目狀態改為已結束，暫停新連結訪問；恢復發佈中後繼續監控下一檔。',
            progressCurrent: '當前進度',
            progressCompleted: '已完成 {done} / {total}',
            progressNext: '下一暫停',
            progressThresholds: '暫停閾值',
            progressAdd: '添加',
            progressThresholdPlaceholder: '1-99',
            progressThresholdRequired: '請至少設定一個暫停閾值',
            progressThresholdInvalid: '閾值必須是 1-99 的整數',
            progressThresholdDuplicate: '該閾值已存在',
            progressNotEligible: '當前方案存在不限配額或總配額為 0，無法按進度暫停',
            progressPausedAt: '已於 {time} 達到 {threshold}% 自動暫停',
            progressProjectEnded: '項目已結束，恢復發佈中後繼續監控下一閾值',
            progressProjectPaused: '項目已暫停，恢復發佈中後繼續監控下一閾值',
            progressMonitorActive: '監控中',
            progressMonitorOff: '未開啟',
            progressStatusPaused: '已暫停',
            progressStatusEnded: '項目已結束',
            progressStatusUnavailable: '不可用',
            progressStatusPending: '待發佈',
            progressPendingPublish: '項目設計中，發佈後才會開始監控進度並按閾值暫停',
            progressRefresh: '刷新進度',
            progressLoading: '加載中',
            quotaMode: {
                matrix: 'STUB×HEADER矩陣模式',
                single: 'STUB單維度模式',
                unconfigured: '未配置'
            },
            optionLabelDefault: '選項'
        },
        quotaMonitorView: {
            title: '配額監控',
            panelFilterLabel: '選擇panel',
            panelAll: '全部',
            panelPlaceholder: '請選擇panel',
            refresh: '刷新數據',
            back: '返回',
            noQuota: '配額未啟用',
            noQuotaTip: '請先配置並開啟配額控制，再開始收集樣本',
            currentAnswerCount: '當前答題數',
            quotaStatus: '配額狀態',
            enabled: '已開啟',
            disabled: '未開啟',
            schemeDetails: '配額方案詳情',
            matrixDetails: '配額矩陣詳情',
            option: '選項',
            quotaFull: '配額已滿',
            noSchemeData: '暫無配額方案數據',
            loadFail: '配額數據加載失敗',
            retry: '重試',
            messages: {
                dataRefreshed: '數據已刷新'
            }
        },
        sampleStatistics: {
            title: '樣本統計',
            success: '成功樣本量',
            overQuota: '超配額樣本量',
            screened: '甄別樣本量',
            unfinished: '未完成樣本量',
            discarded: '廢棄樣本量',
            totalClicks: '連結點擊量',
            successRate: '成功率',
            loadFail: '樣本統計加載失敗'
        },
    },
    recycle: {
        title: "回收中心",
        id: "項目ID",
        name: "項目名",
        deletedAt: "刪除時間",
        createdAt: "創建時間",
        creator: "創建人",
        restore: "恢復",
        noData: "暫無數據",
        confirmDelete: "確認刪除",
        confirmDeleteTip: "確定要永久刪除此項目嗎？此操作無法撤銷。",
        restoreSuccess: "恢復成功",
        restoreFail: "恢復失敗",
        deleteSuccess: "刪除成功",
        deleteFail: "刪除失敗"
    },
    user: {
        title: "用戶管理",
        id: "用戶ID",
        name: "用戶姓名",
        mobile: "用戶手機",
        email: "用戶郵箱",
        avatar: "用戶頭像",
        confirmDelete: '是否確認刪除用戶ID為"{id}"的數據項？',
        addTitle: "添加用戶",
        editTitle: "修改用戶信息",
        uploadAvatar: "更換頭像",
        uploadSuccess: "上傳成功！",
        uploadFail: "上傳失敗: {msg}",
        uploadTypeError: "上傳頭像圖片只能是 JPG/PNG 格式!",
        uploadSizeError: "上傳頭像圖片大小不能超過 2MB!",
        placeholderName: "請輸入用戶姓名",
        placeholderMobile: "請輸入用戶手機",
        placeholderEmail: "請輸入用戶郵箱",
        placeholderAvatar: "請輸入用戶頭像連結"
    },
    role: {
        title: "角色管理",
        id: "角色編號",
        name: "角色名稱",
        key: "權限字符",
        sort: "顯示順序",
        status: "狀態",
        createTime: "創建時間",
        remark: "備註",
        menuPerm: "選單權限",
        dataPerm: "數據權限",
        assignUser: "分配用戶",
        more: "更多",
        confirmDelete: "是否確認刪除角色編號為\"{id}\"的數據項？",
        addTitle: "添加角色",
        editTitle: "修改角色",
        dataScope: "權限範圍",
        allData: "全部數據權限",
        customData: "自定數據權限",
        deptData: "本部門數據權限",
        deptBelowData: "本部門及以下數據權限",
        selfData: "僅本人數據權限",
        selectAll: "全選/全不選",
        parentLink: "父子聯動",
        loading: "加載中，請稍候",
        remarkPlaceholder: "請輸入內容",
        successAdd: "新增成功",
        successEdit: "修改成功",
        successDelete: "刪除成功",
        successStatus: "{action}成功",
        confirmStatus: '確認要{action}"{name}"角色嗎？',
        assignDataPerm: "分配數據權限",
        assignUserTitle: "分配用戶",
        cancelAuth: "取消授權",
        batchCancelAuth: "批量取消授權",
        closePage: "關閉",
        selectUser: "選擇用戶",
        selectUserTip: "請選擇要分配的用戶",
        selectUserSuccess: "分配成功"
    },
    menu: {
        title: "選單管理",
        name: "選單名稱",
        icon: "圖標",
        sort: "排序",
        perms: "權限標識",
        component: "組件路徑",
        status: "狀態",
        createTime: "創建時間",
        confirmDelete: '是否確認刪除名稱為"{name}"的數據項？',
        addTitle: "添加選單",
        editTitle: "修改選單",
        successAdd: "新增成功",
        successEdit: "修改成功",
        successDelete: "刪除成功",
        placeholderName: "請輸入選單名稱",
        placeholderRouteName: "請輸入路由名稱",
        placeholderPath: "請輸入路由地址",
        placeholderComponent: "請輸入組件路徑",
        placeholderPerms: "請輸入權限標識",
        placeholderQuery: "請輸入路由參數",
        placeholderIcon: "點擊選擇圖標",
        placeholderParentMenu: "選擇上級選單",
        parentMenu: "上級選單",
        menuType: "選單類型",
        directory: "目錄",
        menu: "選單",
        button: "按鈕",
        menuIcon: "選單圖標",
        displaySort: "顯示排序",
        routeName: "路由名稱",
        routeNameTip: "預設不填則和路由地址相同：如地址為：`user`，則名稱為`User`（注意：為避免名字的衝突，特殊情況下請自定義，保證唯一性）",
        isExternalLink: "是否外鏈",
        externalLinkTip: "選擇是外鏈則路由地址需要以`http(s)://`開頭",
        routeAddress: "路由地址",
        routeAddressTip: "訪問的路由地址，如：`user`，如外網地址需內鏈訪問則以`http(s)://`開頭",
        componentPath: "組件路徑",
        componentPathTip: "訪問的組件路徑，如：`system/user/index`，預設在`views`目錄下",
        permissionChar: "權限字符",
        permissionCharTip: "控制器中定義的權限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)",
        routeParams: "路由參數",
        routeParamsTip: "訪問路由的預設傳遞參數，如：`{\"id\": 1, \"name\": \"ry\"}`",
        displayStatus: "顯示狀態",
        displayStatusTip: "選擇隱藏則路由將不會出現在側邊欄，但仍然可以訪問",
        menuStatus: "選單狀態",
        menuStatusTip: "選擇停用則路由將不會出現在側邊欄，也不能被訪問",
        yes: "是",
        no: "否",
        mainCategory: "主類目",
        nameRequired: "選單名稱不能為空",
        sortRequired: "選單順序不能為空",
        pathRequired: "路由地址不能為空"
    },
    header: {
        lang: {
            zh: '簡體中文',
            zh_TW: '繁體中文',
            en: '英文',
            jp: '日文',
            ko: '韓文',
            id: '印度尼西亞文',
        },
        helpDoc: '幫助文件'
    },
    questionEdit: {
        readonlyLocked: '當前專案為僅檢視權限，內容不能修改',
        // 題型名稱
        sortQuestion: '排序題',
        singleQuestion: '單選題',
        multiQuestion: '多選題',
        numberQuestion: '數值題',
        textQuestion: '文本題',
        textareaQuestion: '多行文本題',
        dateQuestion: '日期題',
        timeQuestion: '時間題',
        uploadQuestion: '上傳題',
        scoreQuestion: '評分題',
        scoreStyle: '評分樣式',
        scoreStyleStar: '星星',
        scoreStyleNumber: '數字',
        scoreStyleEmoji: '表情',
        scoreStyleSlider: '滑塊',
        scoreRange: '分值範圍',
        scorePointConfig: '評分點配置',
        scorePointConfigTip: '可分別設置分值、code 和文案',
        scoreValueLabel: '分值',
        scoreCodeLabel: 'Code',
        scoreTextLabel: '文案',
        scoreTextPlaceholder: '請輸入該分值的說明文案',
        titleSaveSuccess: '標題保存成功',
        ratingVeryPoor: '不滿意',
        ratingNormal: '一般',
        ratingGood: '滿意',
        openQuestion: '開放題',
        timestampQuestion: '時間戳',
        selectQuestion: '選擇題',
        cascadeSettings: '級聯設置',
        cascadeLevels: '級聯層級',
        cascadeLevelLabel: '第{level}級選項',
        cascadeOptionsManagement: '級聯選項管理',
        placeholderHint: '提示文本：',
        placeholderInput: '請輸入第{level}級下拉框提示文本',
        manageOptions: '管理選項',
        manageSubOptions: '管理子選項',
        subOptionNamePlaceholder: '請輸入子選項名稱',
        optionTextLabel: '選項文本',
        optionCodeLabel: '選項編碼',
        optionTextPlaceholder: '請輸入選項文本',
        optionCodePlaceholder: '請輸入選項編碼',
        optionCodeDuplicate: '第{level}級選項中存在重複的編碼，請修改',
        optionCodeDuplicateGlobal: '選項中存在重複的編碼，請修改後再保存',
        optionValueDuplicate: '該題中選項值不能重複',
        publishOptionCodeDuplicate: '以下題目存在重複的選項編碼，請修改後再發佈：{questions}',
        matrixSingleQuestion: '矩陣單選題',
        matrixMultiQuestion: '矩陣多選題',
        matrixBlankQuestion: '矩陣填空題',
        matrixStatisticsQuestion: '矩陣統計題',
        matrixCompositionQuestion: '矩陣複合題',
        thermodynamicChartQuestion: '熱力圖題',
        autoRecordQuestion: '過錄題',
        maxDiffQuestion: 'MaxDiff題',
        combinationQuestion: '組合題',
        projectLanguage: '項目語言',
        importQuestions: '導入題目',
        exportGuid: '匯出GUID',
        exportGuidLoading: '正在匯出GUID，資料量較大，請耐心等待...',
        exportGuidSuccess: '匯出GUID成功',
        exportGuidFail: '匯出GUID失敗：{msg}',
        aiTools: 'AI工具',
        projectFile: '項目文件',
        searchPlaceholder: '搜尋題目（標題/題號）',
        quickJump: '快速跳轉',
        searchAndJump: '搜尋題目後選中跳轉',
        refreshOutline: '重整大綱',
        order: '順序',
        orderImportExport: '題號順序匯入匯出',
        projectFileView: {
            exportTitle: '匯出項目',
            importTitle: '導入項目',
            exportJson: '匯出JSON',
            exportExcel: '匯出EXCEL',
            preview: '預覽',
            hidePreview: '隱藏預覽',
            questionNo: '題號',
            questionText: '題幹',
            questionType: '題型',
            manualImport: '手動導入',
            fileLabel: '文件：',
            questionCountLabel: '題目數：{count}',
            dropTitle: '拖拽JSON或Excel文件到此處',
            dropSubtitle: '或點擊該區域/「手動導入」按鈕選擇文件',
            dropTip: '支持 .json、.xlsx、.xls 文件',
            selectAllLabel: '全選 ({selected}/{total})',
            confirmImport: '確認導入',
            importing: '導入中...',
            clear: '清空',
            close: '關閉',
            exportSuccess: '匯出成功',
            exportFail: '匯出失敗',
            projectIdRequired: '項目ID不存在',
            noPreviewQuestions: '沒有可預覽的題目',
            importSuccess: '導入完成',
            importFail: '導入失敗',
            noQuestionsSelected: '未選擇題目',
            importNoQuestionsParsed: '未解析到題目，請檢查Excel模板內容',
            excelParseFailWithMsg: 'Excel文件解析失敗：{msg}',
            duplicateQuestionNos: 'Excel校驗失敗：存在重複題號。重複項：{details}',
            unsupportedFileType: '不支持的文件格式，請選擇JSON或Excel文件',
            fileNoQuestionsData: '文件中未找到題目數據',
            jsonParseFail: '解析失敗：JSON文件格式不正確'
        },
        ai: {
            codingButton: 'AI開放題編碼',
            tableButton: 'AI表格生成',
            reportTitle: 'AI 調研報告',
            notOpen: '暫未開放'
        },
        questionBank: {
            name: '題庫',
            searchPlaceholder: '搜尋題目',
            myBank: '我的題庫',
            publicBank: '公共題庫',
            add: '添加',
            type: '題型',
            category: '分類',
            title: '標題',
            options: '選項',
            unnamedOption: '未命名選項',
            noOptions: '無選項',
            close: '關閉',
            addToForm: '添加到問卷中',
            collect: '收藏',
            addedToFormSuccess: '題目已添加到問卷',
            addFail: '添加失敗',
            collectSuccess: '收藏成功',
            collectFail: '收藏失敗'
        },

        thermo: {
            changeImage: '更換圖片',
            showIndex: '顯示編號',
            maxClicks: '最大點擊次數',
            color: '顏色',
            size: '大小',
            clearPoints: '清空點擊點',
            clickCount: '點擊次數：{count}',
            imageOnlyTip: '僅支持圖片文件'
        },

        // 通用操作
        delete: '刪除',
        clear: '清空',
        addOption: '添加選項',
        batchAdd: '批量添加',
        batchAddTitle: '批量添加選項',
        batchAddHint: '一行一個選項。從 Excel 貼上兩列時，數字列自動識別為選項值；沒有製表符時也支援「1 選項文字」這種空格分隔。識別結果在下方預覽，可拖曳調整最終順序。',
        batchAddPlaceholder: '1\t這是選項A\n2\t這是選項B\n3\t這是選項C',
        batchAddParsedCount: '已識別 {count} 個選項',
        batchAddPreviewTitle: '添加後的完整順序',
        batchAddPreviewEmpty: '貼上內容後，這裡會顯示添加後的完整選項列表',
        batchAddTagNew: '新增',
        batchAddDragTip: '按住整行拖曳可調整順序，值與選項文字均可直接修改',
        batchAddValueTaken: '值 {input} 已被本題其他選項佔用，已自動改為 {value}',
        batchAddValueInvalid: '值 {input} 不是有效的正整數，已自動改為 {value}',
        batchAddValueAdjustedTip: '有 {count} 個選項的值與本題已有選項重複或不合法，已自動改為未佔用的值；將滑鼠移到該行的黃色圖示可查看原因，也可直接改成你想要的值。',
        batchAddRowErrorSummary: '有 {count} 行需要修正後才能確定',
        batchAddRichHint: '該選項含富文本樣式，此處僅顯示純文字；不修改則保留原有樣式',
        batchAddWhitespaceHint: '該選項文字首尾含空格，會原樣保留並在答卷端顯示',
        batchAddModeTab: '按製表符分列',
        batchAddModeSpace: '按空格分列',
        batchAddModeTextOnly: '整行作為選項文字',
        batchAddSuccess: '已添加 {count} 個選項',
        batchAddExistingCount: '原有 {count} 項',
        batchAddRemoveExisting: '刪除原有選項',
        batchAddRemoveExistingHint: '一鍵刪掉上面所有原有選項，只留本次貼上的新選項',
        batchAddRestoreRemoved: '恢復 {count} 項',
        batchAddRestoreRemovedHint: '把剛刪掉的原有選項按原位置放回來',
        batchAddRemoveRowHint: '刪除這一項（原有選項也可以刪）',
        batchAddPreviewEmptyAfterRemove: '原有 {count} 個選項已全部移除；貼上新選項後可繼續，或點上方「恢復」找回原有選項',
        batchAddNeedOneOption: '預覽區至少需要保留 1 個選項',
        batchAddSuccessMixed: '已添加 {added} 個、刪除 {removed} 個選項',
        batchDelete: '批量刪除',
        batchSelectAll: '全選',
        batchSelectOption: '選擇該選項',
        batchSelectedCount: '已選 {count} 項',
        batchDeleteSelected: '刪除所選',
        batchDeleteConfirmMessage: '確定刪除所選的 {count} 個選項嗎？刪除後可用「撤銷」恢復。',
        batchDeleteSuccess: '已刪除 {count} 個選項',
        batchSelectAllRows: '全選行',
        batchSelectAllCols: '全選列',
        batchSelectRow: '選擇該行',
        batchSelectColumn: '選擇該列',
        batchSelectedMatrixCount: '已選 {rows} 行 · {cols} 列',
        batchDeleteConfirmMatrix: '確定刪除所選的 {rows} 行、{cols} 列嗎？刪除後可用「撤銷」恢復。',
        batchDeleteSuccessMatrix: '已刪除 {rows} 行、{cols} 列',
        clearConfirmCount: '共 {count} 題',
        loadingMoreQuestions: '正在載入後面的題目…',
        loadedProgress: '已載入 {loaded}/{total} 題，點擊載入更多',
        richText: '富文本',
        confirm: '確定',
        cancel: '取消',
        addOther: '添加其他',
        addNoneOfAbove: '新增「以上皆無」選項',
        noneOfAbove: '以上皆無',
        exclusiveTag: '此題單選',
        exclusiveTagTip: '此題單選：選中後自動取消其他選項',
        exclusiveRemoveTip: '點擊可刪除邏輯',
        exclusiveExists: '已存在此題單選邏輯',
        exclusiveRemoveConfirm: '刪除後會移除這條「此題單選」邏輯，確定嗎？',
        exclusiveRemoved: '已刪除此題單選邏輯',
        exclusiveAdded: '已添加此題單選邏輯',
        exclusiveLogicSaveFailed: '此題單選邏輯儲存失敗，請到「邏輯」頁手動新增',
        netGroup: 'NET分組',
        netGroupPlaceholder: '請輸入分組名',
        netLabel: '分組：',
        netNone: '-',
        otherOptionLabel: '其他選項：',
        otherInputPlaceholder: '請輸入其他內容',

        // 佔位符
        optionPlaceholder: '請輸入選項',
        numberPlaceholder: '請輸入數字',
        textPlaceholder: '請輸入文本',
        datePlaceholder: '請選擇日期',
        timePlaceholder: '請選擇時間',
        scorePlaceholder: '請評分',
        uploadPlaceholder: '點擊上傳或將文件拖到此處',
        dateFormat: '時間日期格式',
        inputQuestionNo: '請輸入題號',
        scriptType: '腳本類型',
        tags: '標籤',
        previewDialog: {
            title: '題目預覽',
            projectId: '項目ID：',
            questionNo: '題號：',
            refresh: '刷新預覽',
            loading: '加載中...',
            empty: '暫無預覽數據',
            projectOrQuestionIdMissing: '缺少項目或題目ID參數',
            notHtml: '接口未返回HTML內容',
            fetchFail: '獲取預覽失敗',
            fetchFailRetry: '獲取預覽失敗，請稍後重試',
            devicePhone: '手機',
            deviceTablet: '平板',
            devicePc: '電腦'
        },

        // 提示消息
        saveSuccess: '保存成功',
        saveFail: '保存失敗',
        finishConfirmTitle: '設置項目為已結束',
        finishConfirmMessage: '將項目狀態設為「已結束」後，線上問卷將會被鎖定，無法繼續答題或修改。是否繼續？',
        finishConfirmButton: '繼續保存',
        deleteSuccess: '刪除成功',
        deleteFail: '刪除失敗',
        uploadSuccess: '上傳成功',
        uploadFail: '上傳失敗',
        emptyOptionError: '選項內容不能為空',
        optionValueEmpty: '選項值不能為空或 0',
        optionEmptyReverted: '選項內容為空，已恢復原內容；如需刪除請點右側刪除按鈕',
        addQuestionSuccess: '新增題目成功',
        undo: '撤銷',
        undoSuccess: '已撤銷上一步',
        undoNoChange: '沒有可撤銷的變更',
        undoFailed: '撤銷失敗，請重試',
        switchLanguageSuccess: '切換語言成功',
        maxFilesExceeded: '最多只能上傳 {max} 個文件',
        fileSizeExceeded: '文件大小不能超過 {size}MB',

        // 編輯相關
        newOption: '新選項',
        editTitle: '編輯標題',
        editOption: '編輯選項',
        deleteConfirm: '確定要刪除嗎？',
        titleMarkupLostTitle: '標題包含格式',
        titleMarkupLostMessage: '該標題包含富文本格式，直接儲存純文字會遺失格式。確定繼續嗎？（也可點擊「富文本」保留格式編輯）',

        // 引用答案（把前面題目的作答插入題幹）
        answerRef: {
            button: '引用答案',
            buttonTip: '把前面題目的作答插入到題幹裡',
            title: '引用前面題目的答案',
            subtitle: '把前面題目的作答插入到題幹中，答題時會自動替換成受訪者選擇的內容',
            search: '搜尋題號或題幹…',
            empty: '前面沒有可引用的題目',
            loading: '正在載入題目…',
            disabled: '暫不支援',
            disabledTip: '該題型暫不支援引用答案',
            quickInsert: '插入',
            modes: '引用方式',
            modeWhole: '整題答案',
            modeWholeDesc: '引用使用者在這道題上的完整作答',
            modeOther: '「其他」填寫內容',
            modeOtherDesc: '只引用使用者在「其他」裡輸入的文字',
            modeItem: '第 {n} 個被選項',
            modeRow: '第 {n} 行',
            modeCell: '第 {r} 行第 {c} 列',
            modeItemTitle: '第 N 個被選項',
            modeItemDesc: '引用多選題／排序題裡使用者選的第 N 項',
            modeRowTitle: '某一行',
            modeRowDesc: '引用矩陣題這一行的作答',
            modeCellTitle: '某個儲存格',
            modeCellDesc: '引用矩陣題這個儲存格的作答',
            rowPick: '選擇要引用的行',
            cellPick: '點擊表格選擇儲存格',
            otherPick: '選擇哪個「其他」',
            itemPick: '選擇第幾項',
            preview: '範例',
            previewPrefix: '預覽：',
            unanswered: '未作答時顯示：{text}',
            unansweredSample: '[未答題]',
            insert: '插入到題幹',
            cancel: '取消',
            inserted: '已引用',
            dragHint: '直接拖動題幹裡的膠囊調整位置',
            broken: '引用已失效',
            removeRef: '刪除這個引用',
            brokenTip: '這道題已刪除或題號已變更',
            noPreview: '選擇左側題目，查看可引用的內容'
        },
        collectQuestion: '收藏題目',
        collectSuccess: '題目收藏成功',
        collectFail: '收藏失敗',
        nextWaitSeconds: '下一題倒計時(秒)',
        nextWaitSecondsTip: '0 或空表示不啟用',
        // 設計頁狀態
        totalQuestions: '共 {count} 道題目',
        clearAll: '清空所有',
        clearAllTitle: '清空所有題目',
        collapse: '摺疊',
        expand: '展開',
        unnamedQuestion: '（未命名題目）',
        clearConfirmTitle: '確認清空',
        clearConfirmMessage: '確定要清空所有題目嗎？此操作不可恢復。',
        clearedMessage: '已清空所有題目',
        clearPartialFailed: '部分題目刪除失敗，請刷新頁面查看最新狀態',
        clearFailedMessage: '清空失敗: {msg}',
        valueLabel: '值：',
        otherLabel: '其他：',
        other: '其他',
        isOther: '是否其他',
        deleteConfirmTitle: '刪除確認',
        deleteConfirmMessageOption: '確定要刪除此選項嗎？Label：{label}, Code：{code}',
        optionDeleted: '選項已刪除',
        deleteConfirmMessageQuestion: '確定要刪除此題目嗎？題號：{no}, 標題：{title}',
        questionDeleted: '題目已刪除',
        nextWaitSecondsSaveTip: '設置了下一題倒計時後請點擊保存配置',
        defaultTitle: '新題目',
        defaultOption: '選項{index}',

        //父組件
        // ===== 以下為design父組件template新增key，重複的也保留，後續可微調 =====
        edit: '編輯',
        save: '保存配置',
        statistics: '統計',
        data: '數據',
        download: '下載',
        publish: '發布',
        quotaLink: '配額連結',
        quotaLinkMissingConfig: '未配置外部配額系統地址',
        quotaLinkMissingSurveyId: '問卷ID不存在',
        questionType: '題型',
        outline: '大綱',
        basicComponents: '基礎組件',
        advancedComponents: '進階組件',
        myQuestionBank: '我的題庫',
        add: '添加',
        comprehensiveCustomerSatisfactionSurvey: '綜合客戶滿意度調查',
        publicQuestionBank: '公共題庫',
        standardQuestionBankGroup: '標準題庫組',
        standardTextQuestion: '標準文本題',
        standardSingleChoiceQuestion: '標準單選題',
        standardMultipleChoiceQuestion: '標準多選題',
        standardOpenQuestion: '標準開放題',
        standardRatingQuestion: '標準評分題',
        specialQuestionBankGroup: '特殊題庫組',
        specialTextQuestion: '特殊文本題',
        otherQuestionBankGroup: '其他題庫組',
        set: '設定',
        thenExecutionActions: 'THEN執行動作',
        beforeExecution: '執行前',
        duringExecution: '執行中',
        afterExecution: '執行後',
        favoriteScript: '收藏腳本',
        personal: '個人',
        details: '詳情',

        tabSetting: '設定',
        tabLogic: '邏輯',
        tabScript: '腳本',
        options: '選項',
        moreConfig: '更多配置',
        lengthPx: '長度 (px)：',
        widthPercent: '寬度 (%)：',
        minLength: '字數最少：',
        maxLength: '字數最多：',
        minNumber: '最小數值：',
        maxNumber: '最大數值：',
        allowChar: '字符：',
        allowNumber: '數值：',
        allowDecimal: '小數：',
        decimalPlaces: '小數位：',
        fontSelect: '字體選擇',
        fontSize: '字體大小',
        optionSize: '選項大小',
        layoutDirection: '佈局方向',
        horizontal: '橫向',
        vertical: '縱向',
        rowCount: '行數',
        rowWidth: '行寬',
        colCount: '列數',
        colHeight: '列高',
        hideImage: '隱藏圖片',
        operate: '操作',
        saveLogic: '保存邏輯',
        logicList: '邏輯列表',
        selectCondition: '選擇條件',
        selectOption: '選擇選項',
        inputValue: '請輸入值',
        selectRelation: '選擇關係',
        priority: '優先級',
        selectAction: '選擇動作',
        inputText: '請填寫文本',
        inputLink: '請輸入跳轉連結',
        inputQuestionTitle: '請輸入新題幹',
        selectRowCol: '選擇行/列',
        row: '行',
        column: '列',
        selectRowOption: '選擇行選項',
        selectColOption: '選擇列選項',
        conditions: {
            true: '恆真',
            equal: '等於',
            notEqual: '不等於',
            contain: '包含',
            NContain: '不包含',
            isBlank: '為空',
            isNBlank: '不為空',
            countLT: '統計選項少於',
            countGT: '統計選項多於',
            countEQ: '統計選項等於',
            countNE: '統計選項不等於',
            countGE: '統計選項大於等於',
            countLE: '統計選項小於等於',
            countVLT: '統計值小於',
            countVGT: '統計值大於',
            countVEQ: '統計值等於',
            countVGE: '統計值大於等於',
            countVLE: '統計值小於等於'
        },
        actions: {
            thisValues: '選項賦值',
            thisShowOptions: '顯示選項',
            thisRandom: '打亂選項',
            thisHide: '隱藏選項',
            thisMatchShow: '展示匹配選項',
            thisDifferentShow: '展示不匹配選項',
            thisSingle: '此題單選',
            thisAutoRecord: '自動記錄題目選項',
            thisAutoRecVal: '自動記錄值',
            thisFixShow: '匹配值選項',
            thisRandom_v2: '打亂行/列',
            thisHide_v2: '隱藏行/列',
            goto: '跳轉',
            gotoLink: '訪問連結',
            gotoNQ: '跳轉未答題',
            goBack: '返回上題',
            close: '結束問卷',
            screenClose: '結束訪問',
            alert: '彈窗',
            confirm: '彈出確認彈窗',
            skipThis: '跳過此題',
            notSkip: '不能跳過此題',
            canBlank: '可以為空',
            otherBlank: '其他題可以為空',
            lock: '鎖題',
            unlock: '不鎖題',
            setQuestionTitle: '修改題幹'
        },
        connectors: {
            ifPrefix: '如果 ',
            thenPrefix: '則 ',
            andConnector: ' 並且 '
        },
        logic: {
            and: '並且',
            or: '或者',
            end: '結束'
        },
        searchScript: '搜尋腳本',
        detail: '詳情',
        scriptEdit: '腳本編輯',
        scriptDetail: '腳本詳情',
        search: '搜尋',
        questionNo: '題號',
        logicSettings: '邏輯設定',
        refreshLogic: '刷新邏輯',
        addLogic: '添加邏輯',
        ifConditionSettings: 'IF條件設定',
        favoriteScriptList: '腳本收藏列表',
        public: '公共',
        apply: '應用',
        saveScript: '保存腳本',
        optionContent: '選項內容',
        changeType: '更改題型',
        changeTypeDialog: {
            title: '修改題型',
            currentQuestion: '當前題',
            currentType: '當前題型',
            targetType: '目標題型',
            targetPlaceholder: '請選擇目標題型'
        },
        copyOptions: {
            title: '複製選項',
            currentQuestion: '當前題',
            sourceQuestion: '來源題',
            sourcePlaceholder: '請選擇來源題',
            rulesTitle: '題型選項複製規則',
            ruleSingleMultiSort: '單選題 ↔ 多選題 ↔ 排序題',
            ruleMatrix: '矩陣單選題 ↔ 矩陣多選題 ↔ 矩陣統計題 ↔ 矩陣填空題',
            notSetTitle: '未設置題目',
            success: '選項複製成功',
            failWithMsg: '複製失敗：{msg}',
            notFoundSource: '未找到來源題：{qno}',
            notFoundTarget: '未找到目標題：{qno}',
            failGeneral: '複製選項失敗：{msg}'
        },
        copyLogic: {
            title: '複製邏輯',
            sourceQuestion: '來源題',
            sourcePlaceholder: '請選擇來源題',
            promptTitle: '複製邏輯',
            promptMessage: '請輸入來源題題號（如：Q5）',
            selectSourceTip: '請選擇來源題',
            noSource: '未獲取到來源題邏輯',
            sourceEmpty: '來源題暫無邏輯',
            fail: '複製邏輯失敗',
            failWithMsg: '複製邏輯失敗：{msg}',
            projectIdMissing: '項目ID缺失，無法複製邏輯',
            typeMismatchConfirmTitle: '類型不一致',
            typeMismatchConfirm: '來源題({source})類型為 {sourceType}，與目標題({target})類型 {targetType} 不一致，仍要覆蓋保存嗎？',
            notFoundSource: '未找到來源題：{qno}'
        },
        changeTypeMessages: {
            notSelected: '未選中題目',
            noSupport: '該題型不支持直接轉換',
            sameType: '目標題型與當前一致，無需修改',
            success: '修改題型成功',
            failedWithMsg: '修改失敗：{msg}',
            failedGeneral: '修改題型失敗：{msg}'
        },
        selectQuestionFirst: '請先選擇一個問題',
        currentQuestionLabel: '當前題目：',
        loopQuestion: '循環題',
        maxdiff: {
            mostImportant: '最重要',
            leastImportant: '最不重要',
            mostLabel: '最重要標籤',
            leastLabel: '最不重要標籤',
            instruction: '請選擇最重要和最不重要的屬性',
            instructionLabel: '說明文本',
            instructionHint: '展示在任務預覽的標題處',
            alignment: '對齊方式',
            alignCenter: '居中',
            alignLeft: '左對齊',
            attributesPerTask: '每任務屬性數',
            attributesPerTaskHint: '範圍 3–{max}，且不超過屬性數（當前 {count}）',
            totalTasks: '任務總數',
            totalTasksHint: '最多可生成 {max} 個任務',
            taskPreview: '任務預覽',
            prev: '上一個',
            next: '下一個'
        },
        matrix: {
            functionA: '功能A',
            functionB: '功能B',
            functionC: '功能C',
            projectA: '項目A',
            projectB: '項目B',
            projectC: '項目C',
            satisfied: '滿意',
            average: '一般',
            dissatisfied: '不滿意',
            evaluate: '評價',
            suggestion: '建議',
            remark: '備註',
            enterEvaluate: '請輸入評價',
            enterSuggestion: '請輸入建議',
            enterRemark: '請輸入備註',
            firstQuarter: '第一季度',
            secondQuarter: '第二季度',
            thirdQuarter: '第三季度',
            fourthQuarter: '第四季度',
            enterValue: '請輸入數值',
            score: '評分',
            select: '選擇',
            exportOrientation: '主方向',
            perRow: '列',
            perCol: '欄',
            exclusiveLabel: '以上皆無',
            exclusiveNone: '關閉',
            exclusiveRow: '僅列',
            exclusiveCol: '僅欄',
            exclusiveBoth: '列+欄',
            transposeStructure: '題目結構轉置',
            total: '合計'
        },

        // 特殊組件
        specialComponents: {
            loopQuestion: '循環題',
            loopQuestionDesc: '可重複填寫的題目組',
            addLoop: '添加循環',
            deleteLoop: '刪除循環',
            loopTitle: '循環標題',
            loopContent: '循環內容',
            minLoops: '最少循環次數',
            maxLoops: '最多循環次數',
            loopSettings: '循環設定',
            loopPreview: '循環預覽',
            enableLoop: '啟用循環',
            disableLoop: '停用循環',
            loopIndex: '循環序號',
            currentLoop: '當前循環',
            totalLoops: '總循環數',
            loopValidation: '循環驗證',
            loopRequired: '必填循環',
            loopOptional: '選填循環'
        },

        // 循環題相關（避免與題型名稱重複鍵衝突）
        loopQuestionConfig: {
            title: '循環題',
            description: '可重複填寫的題目組',
            addQuestion: '添加題目',
            removeQuestion: '移除題目',
            questionList: '題目列表',
            loopSettings: '循環設定',
            minCount: '最少循環次數',
            maxCount: '最多循環次數',
            defaultCount: '預設循環次數',
            allowAdd: '允許添加',
            allowRemove: '允許移除',
            loopLabel: '循環標籤',
            itemLabel: '項目標籤',
            addButton: '添加按鈕文字',
            removeButton: '移除按鈕文字',
            confirmRemove: '確認移除',
            emptyLoop: '空循環',
            loopIndex: '循環索引',
            validation: '驗證設定',
            required: '必填設定',
            preview: '預覽模式'
        },
        tabMoreSetting: '設定',
        tabMoreDisplay: '顯示',
        tabMoreImage: '圖片',
        fontMicrosoftYaHei: '微軟雅黑',
        fontSimSun: '宋體',
        fontSimHei: '黑體',
        fontArial: 'Arial',
        Statistics: {
            version: '版本',
            versionPlaceholder: '請輸入數字版本號',
            versionTooltip: '只能輸入純數字，如：1、2、3',
            linkType: '連結類型',
            linkTypeAll: '全部',
            linkTypeTest: '測試連結',
            linkTypeProd1: '正式連結1',
            linkTypeProd2: '正式連結2',
            linkTypeOffline: '離線版本',
            linkTypeCustom: '自定義',
            dateRange: '日期範圍',
            filter: '篩選',
            dashboardTitle: '數據分析儀表板',
            effectiveCount: '有效回收量',
            totalCount: '總調查量',
            recoveryRate: '回收率',
            avgTime: '平均完成時間',
            deviceModel: '設備型號',
            dailyTrend: '天收集趨勢',
            respondentLocation: '受訪者屬地分布',
            briefRecordList: '簡要記錄列表',
            projectId: '項目ID',
            ipAddress: 'IP地址',
            deviceType: '設備型號',
            time: '時間',
            duration: '用時',
            singleChoiceTitle: '單選題答案分布',
            singleChoiceOption: '選項分布',
            multipleChoiceTitle: '多選題答案分布',
            multipleChoicePeople: '選擇人數',
            optionA: '選項A',
            optionB: '選項B',
            optionC: '選項C',
            optionD: '選項D',
            china: '中國',
            usa: '美國',
            pc: 'PC',
            europe: '歐洲',
            asiaOther: '亞洲其他',
            other: '其他',
            ios: 'iOS',
            android: 'Android',
            windows: 'Windows',
            mac: 'Mac',
        },
        dataView: {
            listTitle: '答題記錄',
            id: 'ID',
            projectId: '項目ID',
            version: '版本',
            linkType: '連結類型',
            status: '狀態',
            statusMap: {
                filter: '被篩選',
                voided: '廢卷',
                active: '進行中',
                out: '配額滿',
                done: '已完成',
            },
            startTime: '答題開始時間',
            endTime: '答題結束時間',
            createTime: '答題結束時間',
            duration: '答題用時',
            ipAddress: 'IP地址',
            deviceType: '設備型號',
            device: '具體設備',
            actions: '操作',
            edit: '編輯',
            details: '詳情',
            editAnswer: '編輯答案',
            cancel: '取消',
            save: '保存',
            refresh: '刷新數據',
            pageTotal: '共 {total} 條記錄',
            loading: '正在加載數據...',
            noRecords: '暫無答題記錄',
            notify: {
                filterApplied: '篩選條件已應用',
                filterReset: '篩選條件已重置',
                questionFilterApplied: '題目篩選條件已應用',
                questionFilterReset: '題目篩選條件已重置',
                noRecordsMatched: '暫無符合條件的答題記錄',
                loadSuccess: '成功加載 {count} 條記錄',
                fetchFail: '獲取答題記錄失敗，請檢查網絡連接',
                networkRetryText: '網絡連接失敗，是否重試？',
                retry: '重試'
            }
        },
        downloadView: {
            title: '數據下載',
            subtitle: '選擇文件格式與下載格式',
            exportOptions: '匯出選項',
            exportOptionsSubtitle: '選擇匯出格式和選項',
            fileFormat: '文件格式',
            exportOptionsTitle: '匯出選項',
            dateRange: '時間範圍',
            startDatePlaceholder: '開始日期',
            endDatePlaceholder: '結束日期',
            startExport: '開始匯出',
            excel: 'Excel',
            excelDesc: '適用於數據分析和處理',
            csv: 'CSV',
            csvDesc: '通用格式，支援所有設備',
            pdf: 'PDF',
            pdfDesc: '適合列印和分享',
            json: 'JSON',
            jsonDesc: '適用於開發者和系統集成',
            spss: 'SPSS',
            spssDesc: '適用於統計分析軟體',
            includeAnswerTime: '包含答題時間',
            includeDeviceInfo: '包含設備信息',
            includeIpAddress: '包含IP地址',
            includeLocation: '包含地理位置',
            includeUserId: '包含用戶標識',
            includeAnswerType: '包含答案類型',
            includeQuestionAnswers: '包含問卷答案',
            exportImageAnswer: '匯出圖片答案',
            surveyStatus: '問卷狀態',
            statusAll: '全部',
            statusAnswered: '完成',
            compositeSplit: '複合題拆分',
            dataMode: '數據形式',
            durationUnit: '用時單位',
            durationSecond: '秒',
            durationMinute: '分鐘',
            durationHms: '時:分:秒',
            stripRichText: '富文本',
            code: 'Code',
            label: 'Label',
            comingSoon: '功能待開發，敬請期待',
            exportFail: '匯出失敗',
            spssExportTypeError: 'SPSS 匯出失敗（返回類型異常）',
            spssExportEmptyFile: 'SPSS 匯出失敗（文件為空）',
            spssExportFail: 'SPSS 匯出失敗',
            audio: '音訊',
            audioDesc: '批量下載所有錄音文件',
            image: '圖片',
            imageDesc: '批量下載所有上傳題文件',
            language: '語言',
            languageDefault: '預設(不傳)',
        },
        projectLanguageView: {
            title: '項目語言管理',
            projectId: '項目ID: {id}',
            exportBtn: '匯出語言文件',
            exportDesc: '匯出當前問卷的語言模板文件(Excel格式)',
            uploadBtn: '上傳語言文件',
            uploadDesc: '上傳語言文件更新問卷翻譯',
            close: '關閉',
            projectIdRequired: '項目ID不能為空',
            exportSuccess: '語言文件匯出成功',
            exportFail: '匯出失敗：{msg}',
            uploadTypeError: '只能上傳Excel文件!',
            uploadSizeError: '文件大小不能超過10MB!',
            uploadSuccess: '語言文件導入成功!',
            uploadFail: '導入失敗，請重試'
        },
        thirdPartyConfigView: {
            title: '項目面板配置',
            enableLabel: '是否開啟',
            open: '開啟',
            close: '關閉',
            addPanel: '新增面板',
            loading: '正在加載面板列表...',
            empty: '暫無面板配置',
            emptyHint: '點擊右上角按鈕添加第一個面板'
        },
        thirdPartyConfig: {
            typeSelection: {
                title: '選擇配置類型',
                defaultTitle: '第三方',
                defaultDesc: '配置第三方連結和回傳參數',
                emailTitle: '第三方郵件推送',
                emailDesc: '配置郵件發送和受訪者管理',
                confirm: '確認選擇',
                back: '返回選擇配置類型'
            },
            steps: {
                emailConfig: '郵箱配置',
                uploadRespondents: '上傳受訪者',
                thirdpartyConfig: '第三方'
            },
            data: {
                title: '數據管理',
                downloadTemplate: '下載模板',
                uploadData: '上傳數據',
                uploading: '上傳中...',
                clearData: '清空數據',
                searchPlaceholder: '請輸入郵箱地址搜尋',
                table: {
                    guid: 'GUID',
                    email: '郵箱',
                    subject: '郵件主題',
                    content: '郵件內容',
                    country: '國家',
                    firstTime: '首次時間',
                    lastTime: '最後時間',
                    total: '總數',
                    status: '狀態',
                    statusDesc: '狀態描述'
                }
            },
            email: {
                title: '郵箱配置',
                panelName: '面板名稱',
                panelNamePlaceholder: '請輸入面板名稱',
                emailAddress: '郵箱地址',
                emailPlaceholder: 'admin@example.com',
                smtpServer: 'SMTP伺服器',
                smtpPlaceholder: 'smtp.qq.com',
                password: '密碼/授權碼',
                passwordPlaceholder: '••••',
                port: '端口號',
                save: '保存郵箱配置'
            },
            thirdparty: {
                title: '第三方',
                panelName: '面板名稱',
                panelNamePlaceholder: '請輸入面板名稱',
                links: '連結',
                linksPlaceholder: 'survey.test1.com;survey.test2.com',
                callback: '回傳',
                mappingTitle: '參數映射關係',
                addMapping: '添加映射',
                paramKeyPlaceholder: '參數名(如:a)',
                paramValuePlaceholder: '映射值(如:uid)',
                emptyMapping: '暫無映射關係，點擊上方按鈕添加',
                status: '狀態',
                statusPlaceholder: 's',
                complete: '完成',
                completeUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=1',
                screen: '篩選',
                screenUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=2',
                quota: '配額',
                quotaUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=3',
                flexible: '靈活跳轉',
                flexibleTip: '開啟後按連結攜帶的 return 跳轉，三個回調地址將隱藏',
                save: '保存第三方'
            },
            validation: {
                email: {
                    nameRequired: '請輸入面板名稱',
                    nameLength: '長度在 1 到 50 個字符',
                    emailRequired: '請輸入郵箱地址',
                    emailInvalid: '請輸入正確的郵箱地址',
                    smtpRequired: '請輸入SMTP伺服器地址',
                    passwordRequired: '請輸入密碼或授權碼',
                    portRequired: '請輸入端口號',
                    portRange: '端口號範圍為 1-65535'
                },
                thirdparty: {
                    nameRequired: '請輸入面板名稱',
                    linksRequired: '請輸入連結地址',
                    mappingRequired: '請至少添加一個參數映射',
                    mappingIncomplete: '請完善所有映射關係的參數名和映射值',
                    statusRequired: '請輸入狀態標識',
                    completeUrlRequired: '請輸入完成回傳地址',
                    screenUrlRequired: '請輸入篩選回傳地址',
                    quotaUrlRequired: '請輸入配額回傳地址'
                }
            },
            notify: {
                fetchPanelListFail: '獲取面板列表失敗',
                panelOpened: '面板已開啟',
                panelClosed: '面板已關閉',
                updatePanelStatusFail: '更新面板開啟狀態失敗',
                getPanelDetailFail: '獲取面板詳情失敗',
                deletePanelSuccess: '刪除成功',
                deletePanelFail: '刪除失敗',
                emailUpdateSuccess: '郵箱配置更新成功',
                emailCreateSuccess: '郵箱配置創建成功',
                emailSaveFail: '保存郵箱配置失敗',
                thirdpartyUpdateSuccess: '第三方更新成功',
                thirdpartyCreateSuccess: '第三方創建成功',
                thirdpartySaveFail: '保存第三方失敗',
                allUpdateSuccess: '配置更新成功',
                allCreateSuccess: '配置創建成功',
                allSaveFail: '保存配置失敗',
                completeAllSteps: '配置完成！所有步驟已完成。',
                templateDownloadSuccess: '模板下載成功',
                templateDownloadFail: '下載模板失敗',
                searchFail: '搜尋失敗',
                uploadFileTypeError: '只能上傳Excel文件!',
                uploadFileSizeError: '文件大小不能超過10MB!',
                uploadFileSuccess: '文件上傳成功!',
                uploadFileFail: '文件上傳失敗，請重試',
                uploadDataAllDone: '數據上傳完成，所有配置已完成！您可以關閉此彈窗。',
                clearDataSuccess: '數據清空成功',
                clearDataFail: '清空數據失敗',
                saveDataConfigSuccess: '數據配置保存成功',
                saveDataConfigFail: '保存數據配置失敗'
            },
            nav: {
                prev: '上一步',
                next: '下一步',
                complete: '完成'
            }
        },
        publishProject: {
            title: '發布項目',
            historyLink: '歷史連結',
            generateLink: '生成連結',
            moreLinks: '更多連結',
            downloadLink: '下載連結',
            format: '格式',
            linkGenerator: '問卷連結生成器',
            fixedLink: '固定連結生成',
            prod1: '正式連結1',
            prod1Tip: '帶 guid 和 ip控制',
            prod2: '正式連結',
            prod2Tip: '用於正式投放，自動開啟問卷編號與斷點續答',
            test: '測試連結',
            testTip: '帶導航欄，顯示上一題按鈕',
            ipCtrlDeveloping: 'IP 控制功能仍在開發中',
            breakpointAutoCheckedTip: '勾選{source}後，答題斷點控制會自動勾選',
            breakpointControlledTip: '答題斷點控制不能單獨勾選，請透過 guid 控制或問卷編號開啟來聯動',
            offline: '離線連結',
            offlineTip: '離線連結',
            custom: '自定義連結',
            customTip: '自定義連結',
            customLink: '定制連結生成',
            accessControl: '訪問控制',
            ipCtrl: 'IP控制',
            guidCtrl: 'GUID控制',
            surveyIdCtrl: '問卷編號開啟',
            collaborationCtrl: '協作模式',
            breakpointCtrl: '答題斷點控制',
            externalIdCtrl: '外部標識斷點',
            questionnaireIdMode: '問卷編號模式',
            questionnaireIdModeDigits: '純數字',
            questionnaireIdModeSymbolPlusDigits: '字母+數字',
            questionnaireIdLength: '數字長度',
            displayOptions: '顯示選項',
            showNav: '顯示導航欄',
            showPrev: '顯示上一題按鈕',
            offlineSubmit: '離線連結報別重答',
            record: '錄音開啟',
            fixedOption: '固定連結',
            fixedOptionLockedTip: '固定連結為發佈必選項，不可取消',
            clearOldData: '清除舊數據',
            createLink: '創建連結',
            generatedLink: '生成的連結',
            placeholder: '請先點擊創建連結',
            copy: '複製',
            open: '打開',
            copySuccess: '連結已複製到剪貼簿',
            generateSuccess: '連結生成成功！',
            generateFail: '生成失敗',
            downloadPlaceholder: '點擊生成下載連結',
            externalDownloadTitle: '外部下載連結',
            externalDownloadPlaceholder: '外部下載連結',
            surveyStatus: '問卷狀態',
            answered: '已答',
            downloadDataMode: '數據形式',
            label: '標籤',
            code: '編碼',
            compositeSplit: '複合題拆分',
            language: '語言',
            durationUnit: '用時單位',
            durationSecond: '秒',
            durationMinute: '分鐘',
            durationHms: '時:分:秒',
            stripRichText: '去除富文本',
            languageDefault: '預設(不傳)',
            toggleOn: '開啟',
            history: '歷史連結',
            all: '全部',
            prod: '正式',
            testCategory: '測試',
            id: '編號',
            link: '連結',
            category: '分類',
            type: '類型',
            createTime: '創建時間',
            disabled: '是否禁用',
            yes: '是',
            no: '否',
            version: '版本',
            tags: '標籤',
            // 完成狀態發布攔截
            finishBlockedTitle: '無法發布',
            finishBlockedMessage: '問卷已結束，請調整問卷狀態後再發布',
            finishBlockedButton: '知道了',
            pausedBlockedTitle: '無法發布',
            pausedBlockedMessage: '問卷已暫停，請先恢復發佈中後再發布',
            pausedBlockedButton: '知道了',
            clearConfirmTitle: '清除數據確認',
            clearConfirmMessage: '發布前將清除歷史答題數據，是否確認繼續？',
            clearConfirmOk: '繼續',
            clearConfirmCancel: '取消清除',
            theme: '主題',
            themeDefault: '預設',
            themeLuxury: '奢侈品',
            quotaOptions: '配額選項',
            quotaAll: '全部配額',
            quotaHidden: '隱藏配額',
            quotaType: '類型',
            quotaHiddenRatio: '隱藏比例',
            quotaHiddenRatioPlaceholder: '請輸入隱藏比例',
            quotaHiddenRatioInvalid: '隱藏比例只能輸入數字，且必須大於1小於100',
            panelAll: '全部',
            confirmQuotaParams: '確認參數',
            quotaPanelRequired: '請選擇panel',
            quotaModeRequired: '請選擇配額模式',
            quotaNeedConfirm: '請先點擊確認參數生成外部連結',
            quotaModeEmpty: '配額參數生成失敗，請重試',
            quotaConfirmSuccess: '配額參數確認成功',
            quotaConfirmFail: '配額參數確認失敗',
            externalQuotaTitle: '外部配額連結',
            externalQuotaPlaceholder: '請選擇配額參數'
        },
        resourceManagement: {
            resourceManagement: '資源管理',
            title: '資源管理',
            upload: '上傳資源',
            searchPlaceholder: '搜尋資源',
            id: 'ID',
            name: '資源名稱',
            projectId: '項目ID',
            createTime: '創建時間',
            url: '資源連結',
            actions: '操作',
            copyLink: '複製連結',
            delete: '刪除',
            confirmDelete: '確認刪除該資源嗎？',
            confirm: '提示',
            deleteSuccess: '刪除成功',
            deleteFail: '刪除失敗',
            copySuccess: '連結已複製到剪貼簿',
            fetchFail: '獲取資源列表失敗',
            pageTotal: '共 {total} 條',
        },
        resourceUpload: {
            title: '上傳資源',
            name: '資源名稱',
            namePlaceholder: '請輸入資源名稱',
            file: '資源附件',
            uploadText: '將文件拖到此處，或',
            clickUpload: '點擊上傳',
            uploadTip: '注意：大小限制在100MB（支援 jpg、png、pdf、doc、docx、xls、xlsx 格式）',
            cancel: '取 消',
            confirm: '確 定',
            fileTypeError: '文件格式不支援',
            fileSizeError: '文件大小不能超過100MB',
            nameRequired: '請輸入資源名稱',
            fileRequired: '請選擇上傳文件',
            uploadSuccess: '上傳成功',
            uploadFail: '上傳失敗',
            deleteFail: '刪除資源失敗，請重試',
        },
    },
    profileView: {
        title: '個人資訊',
        back: '返回',
        edit: '編輯',
        save: '保存',
        cancel: '取消',
        username: '用戶名',
        avatar: '頭像',
        changeAvatar: '更換頭像',
        email: '郵箱',
        phone: '手機號',
        usernameRequired: '請輸入用戶名',
        usernameLength: '長度在 3 到 20 個字符',
        emailRequired: '請輸入郵箱地址',
        emailFormat: '請輸入正確的郵箱地址',
        phoneRequired: '請輸入手機號',
        phoneFormat: '請輸入正確的手機號',
        saveSuccess: '保存成功',
        saveFail: '保存失敗',
        avatarTypeError: '上傳頭像圖片只能是 JPG 格式!',
        avatarSizeError: '上傳頭像圖片大小不能超過 2MB!',
    },
    notFound: {
        title: '404',
        pageNotFound: '頁面未找到',
        searching: '我們正在努力尋找您想要的頁面...',
        backHome: '返回首頁',
    },
    iconSelect: {
        placeholder: '請輸入圖標名稱',
    },
    tinymce: {
        placeholder: '在這裡輸入文字',
    },
    favoritesCenter: {
        title: '收藏中心',
        subtitle: '管理你的題目和腳本收藏',
        add: '新增收藏',
        name: '名稱',
        type: '類型',
        content: '內容',
        scope: '範圍',
        personal: '個人',
        public: '公共',
        question: '題目',
        script: '腳本',
        scriptType: '腳本類型',
        scriptTypeBefore: '執行前',
        scriptTypeMiddle: '執行中',
        scriptTypeAfter: '執行後',
        tag: '標籤',
        remark: '備註',
        uploader: '上傳者',
        createTime: '創建時間',
        actions: '操作',
        edit: '編輯',
        delete: '刪除',
        collect: '收藏',
        approve: '通過',
        reject: '拒絕',
        filterName: '收藏名稱',
        filterType: '類型',
        filterScope: '範圍',
        filterSearch: '搜尋',
        dialogAdd: '新增收藏',
        dialogEdit: '編輯收藏',
        dialogUneditable: '題目收藏不可編輯',
        dialogCancel: '取消',
        dialogConfirm: '確定',
        deleteConfirm: '確定刪除該收藏嗎？',
        deleteSuccess: '刪除成功',
        deleteFail: '刪除失敗',
        addSuccess: '新增成功',
        editSuccess: '編輯成功',
        collectConfirm: '確定收藏該{type}到個人收藏嗎？',
        collectSuccess: '{type}收藏成功',
        collectFail: '收藏失敗：{msg}',
        personalCollect: '個人收藏',
        publicCollect: '公共收藏',
        pendingAudit: '待審核',
        approvedPublic: '已轉公',
        auditEdit: '審核編輯',
        auditSuccess: '審核成功',
        rejectConfirm: '確定拒絕該轉公申請嗎？',
        noEditTip: '題目收藏不可編輯',
        scriptScope: '腳本範圍',
        personalScript: '個人腳本',
        publicScript: '公共腳本',
        personalScriptTip: '僅自己可見',
        publicScriptTip: '所有用戶可見',
        page: '頁碼',
        pageSize: '每頁條數',
    },
    pricing: {
        login: '登入',
        register: '註冊',
        heroTitle: '選擇適合您的版本',
        heroSubtitle: '靈活的定價方案，滿足不同規模企業的需求',
        year: '年',
        yearFrom: '年起',
        recommended: '推薦',
        buyNow: '立即購買',
        contactSales: '聯繫銷售',
        freeTrial: '免費試用',
        contactMsg: '請通過客服熱線或在線客服聯繫我們獲取更多信息',
        heroEyebrow: 'YiSurvey Pricing',
        heroLine1: '按調研產能，',
        heroLine2: '選擇適合',
        heroLine3: '團隊的方案。',
        heroDescription: '把預算換成清晰可交付的問卷額度、回收能力、分析深度和部署方式。標準版、尊享版、旗艦版分別對應日常調研、自建研究團隊和大型組織部署。',
        purchasePathLabel: '購買路徑',
        routeCapabilities: '產品能力',
        routePlans: '價格方案',
        routeSales: '聯繫銷售',
        viewPlans: '查看方案',
        proposalIndex: '方案索引',
        proposal: {
            standard: '10萬答卷 / 5個子帳號',
            premium: '20萬答卷 / AI洞察分析',
            flagship: '30萬答卷 / 本地化部署',
            flagshipPrice: '¥45,368 起'
        },
        axis: {
            design: '設計',
            send: '發送',
            collect: '回收',
            analyze: '分析',
            integrate: '集成'
        },
        capacityTitle: '問卷創建 / 樣本回收 / 數據交付',
        capacityDescription: '每檔方案都對應一條完整調研鏈路，只是在規模、自動化能力和交付深度上逐級增強。',
        plansEyebrow: 'Plans',
        plansTitle: '三檔方案，覆蓋從中小企業到本地化部署。',
        comparisonRailTitle: '詳細功能對比',
        answerQuota: '答卷額度',
        administrators: '管理員',
        deliveryFocus: '交付重點',
        matrixEyebrow: 'Capability Matrix',
        comparisonDescription: '按設計、發送、回收、分析和系統集成拆開比較，方便採購、業務和技術團隊一起判斷。',
        helpEyebrow: 'Need Help?',
        ctaDescription: '立即註冊即可免費體驗企業標準版功能；如果需要本地化部署、發票或合同條款，可以直接聯繫銷售。',
        footerCopyright: '易調研系統 YiSurvey. All rights reserved.',
        backHome: '返回首頁',
        emailSubject: '諮詢易調研系統價格方案',
        emailBody: '您好，我想了解易調研系統的價格方案，請聯繫我。',
        standard: {
            name: '企業標準版',
            desc: '適合中小企業',
            kicker: 'Standard Capacity',
            answerCap: '10萬份',
            adminCap: '5個子帳號',
            serviceCap: '基礎服務',
            f1: '每日創建問卷100份',
            f2: '回收答卷10萬份',
            f3: '贈送5個子帳號管理員',
            f4: '專屬服務顧問 + 基礎考試',
            f5: '基礎數據分析'
        },
        premium: {
            name: '企業尊享版',
            desc: '適合中大型企業',
            kicker: 'Recommended',
            answerCap: '20萬份',
            adminCap: '5個子帳號',
            serviceCap: 'AI洞察',
            f1: '問卷創建數量無限制',
            f2: '回收答卷20萬份（可擴增）',
            f3: '贈送5個子帳號管理員',
            f4: '品牌自定義 + 360°測評',
            f5: '完整考試 + AI洞察分析'
        },
        flagship: {
            name: '企業旗艦版',
            desc: '適合大型企業/政府/高校',
            kicker: 'Enterprise Deployment',
            answerCap: '30萬份',
            adminCap: '10個子帳號',
            serviceCap: '本地化',
            f1: '問卷創建數量無限制',
            f2: '回收答卷30萬份（可擴增）',
            f3: '贈送10個子帳號管理員',
            f4: '金牌服務顧問 + 本地化部署',
            f5: 'CSS/JS自定義 + 多語言定製'
        },
        comparisonTitle: '詳細功能對比',
        colFeature: '功能',
        ctaTitle: '還沒想好選擇哪個版本？',
        ctaSubtitle: '立即註冊即可免費體驗企業標準版功能',
        group: {
            design: '設計問卷',
            send: '發送問卷',
            collection: '回收答卷',
            analysis: '數據分析',
            satisfaction: '解決方案-滿意度評估',
            systemIntegration: '系統集成'
        },
        row: {
            surveyLimit: '可發佈/可創建問卷數量',
            validPeriod: '單份問卷填寫有效期',
            questionTypes: '題型',
            logicRelation: '邏輯關係',
            formula: '計算公式',
            quota: '設置配額',
            passwordProtect: '問卷密碼保護',
            conditionalAction: '答題完成後按條件處理',
            duplicateCheck: '重複填寫限制',
            breakpointResume: '斷點續答',
            externalQuery: '對外查詢功能',
            modifyAnswer: '填寫者修改答卷',
            pageTimer: '控制填寫頁面時間',
            webEmbed: '網站集成',
            emailSend: '郵件發送',
            transferSurvey: '轉移問卷',
            customSource: '自定義來源',
            customUrlParam: '自定義鏈接參數',
            maxAnswers: '單份問卷最大填寫人次',
            fileSpace: '上傳文件題空間',
            autoFilterInvalid: '使用規則自動篩選無效答卷',
            downloadReport: '下載調查報告(Word/Excel/SPSS格式)',
            exportWord: '導出答案到Word/PDF',
            customWordExport: '自定義word模板導出',
            batchDownload: '附件批量下載',
            shareData: '分享詳細數據',
            sampleService: '樣本服務(收費)',
            crossAnalysis: '交叉對比分析',
            sourceAnalysis: '答卷來源分析',
            completionRate: '完成率分析',
            npsScore: 'NPS淨推薦值',
            npsTrend: 'NPS變化趨勢',
            swotAnalysis: '維度指標SWOT分析',
            industryCompare: '行業對比',
            multiLevelReport: '多層級報告',
            lowScoreAlert: '低分預警',
            quantitativeAnalysis: '量化分析',
            regionTimeCompare: '地區/時間線對比',
            factorCompare: '影響因子對比',
            dedicatedCloudServer: '獨立租戶雲服務器',
            privateCloudServer: '私有雲服務器'
        },
        val: {
            surveyLimitStd: '總份數無限制(每天最多100份)',
            unlimited: '無限制',
            partialTypes: '部分高級題型不支持',
            logicRef: '跳題/關聯(題目、選項)引用',
            formulaOne: '僅支持一個公式',
            quota50k: '答卷數超過50000，配額規則將不再生效。每個問卷最多添加50個生效的配額規則',
            pwd50k: '√(5萬)',
            pwd500k: '√(50萬)',
            resumeLocal: '僅本地',
            resumeNetwork: '支持本地、網絡斷點續答',
            query5k: '數據5000',
            query20w: '數據20萬',
            param1: '一個參數',
            paramMulti: '多參數帶入且支持加密',
            email60: '最快60封/小時',
            email300: '最快300封/小時',
            source100: '最多100個',
            source30k: '最多30000個',
            answers10w: '10萬',
            answers20w: '20萬',
            space24g: '24G/年|2G/月',
            space120g: '120G/年|15G/月',
            export2000: '最多2000份',
            export2w: '最多2萬份',
            export10w: '最多10萬份',
            cross4: '4個條件',
            cross10: '查詢最多支持10個條件',
            completionNote: '問卷創建於最近6個月內，且最近3個月內至少有一次訪問',
            space240g: '240G/年|20G/月',
            tenThousand: '萬',
            customPaid: '可定製，另外付費'
        }
    },
    brands: {
        common: {
            all: '全部',
            id: 'ID',
            actions: '操作',
            search: '搜尋',
            reset: '重置',
            refresh: '重新整理',
            edit: '編輯',
            delete: '刪除',
            save: '保存',
            cancel: '取消',
            tip: '提示',
            saveFail: '保存失敗',
            deleteFail: '刪除失敗'
        },
        category: {
            title: '品牌分類',
            create: '新增分類',
            listTitle: '分類列表',
            onlyTop: '僅顯示一級',
            searchPlaceholder: '搜尋分類名稱',
            parentPlaceholder: '一級分類',
            childPlaceholder: '二級分類',
            level1: '一級',
            level2: '二級',
            columns: {
                name: '分類名稱',
                level: '層級',
                parent: '父分類'
            },
            createTitle: '新增分類',
            editTitle: '編輯分類',
            deleteConfirmMessage: '確認刪除該分類嗎？',
            form: {
                name: '分類名稱',
                level: '層級',
                parent: '父分類',
                levelPlaceholder: '請選擇層級',
                parentPlaceholder: '二級分類必須選擇父分類',
                nameRequired: '請輸入分類名稱',
                levelRequired: '請選擇層級',
                parentRequired: '二級分類必須選擇父分類'
            }
        }
    },
    request: {
        kickedOut: '您的帳號已在別處登入，您已被迫下線。如非本人操作，請及時修改密碼。',
        badRequest: '請求參數有誤，請檢查填寫內容',
        forbidden: '沒有權限執行該操作',
        notFound: '請求的內容不存在或已被刪除',
        timeout: '請求逾時，請檢查網路後重試',
        payloadTooLarge: '上傳內容過大，請壓縮後重試',
        tooManyRequests: '操作過於頻繁，請稍後再試',
        serverError: '伺服器處理失敗，請稍後重試',
        serviceUnavailable: '服務暫時無法使用，請稍後重試',
        failedWithStatus: '請求失敗（{status}），請稍後重試',
        networkError: '網路連線異常，請檢查網路後重試'
    }
}
